import * as f from "ably";
import { ErrorInfo as pt } from "ably";
import * as bt from "react";
import Tt, { createContext as ar, useRef as $, useEffect as w, useCallback as N, useMemo as cr, useState as P, useContext as ur } from "react";
import { jsx as Mt } from "react/jsx-runtime";
var At = /* @__PURE__ */ ((r) => (r.Trace = "trace", r.Debug = "debug", r.Info = "info", r.Warn = "warn", r.Error = "error", r.Silent = "silent", r))(At || {});
const hr = (r, e, t) => {
  const n = t ? `, context: ${JSON.stringify(t)}` : "", s = `[${(/* @__PURE__ */ new Date()).toISOString()}] ${e.valueOf().toUpperCase()} ably-chat: ${r}${n}`;
  switch (e) {
    case "trace":
    case "debug": {
      console.log(s);
      break;
    }
    case "info": {
      console.info(s);
      break;
    }
    case "warn": {
      console.warn(s);
      break;
    }
    case "error": {
      console.error(s);
      break;
    }
  }
}, lr = (r) => {
  const e = r.logHandler ?? hr;
  return new gr(e, r.logLevel);
}, dr = /* @__PURE__ */ new Map([
  [
    "trace",
    0
    /* Trace */
  ],
  [
    "debug",
    1
    /* Debug */
  ],
  [
    "info",
    2
    /* Info */
  ],
  [
    "warn",
    3
    /* Warn */
  ],
  [
    "error",
    4
    /* Error */
  ],
  [
    "silent",
    5
    /* Silent */
  ]
]);
class gr {
  constructor(e, t) {
    this._handler = e;
    const n = dr.get(t);
    if (n === void 0)
      throw new f.ErrorInfo(`Invalid log level: ${t}`, 5e4, 500);
    this._levelNumber = n;
  }
  trace(e, t) {
    this._write(e, "trace", 0, t);
  }
  debug(e, t) {
    this._write(e, "debug", 1, t);
  }
  info(e, t) {
    this._write(e, "info", 2, t);
  }
  warn(e, t) {
    this._write(e, "warn", 3, t);
  }
  error(e, t) {
    this._write(e, "error", 4, t);
  }
  _write(e, t, n, s) {
    n >= this._levelNumber && this._handler(e, t, s);
  }
}
const fr = {
  logLevel: At.Error
}, _r = (r) => (r = r ?? {}, {
  ...r,
  logLevel: r.logLevel ?? fr.logLevel
}), mr = f.Realtime.EventEmitter;
class K extends mr {
}
const yr = 5e3;
var qe = /* @__PURE__ */ ((r) => (r.Initialized = "initialized", r.Connecting = "connecting", r.Connected = "connected", r.Disconnected = "disconnected", r.Suspended = "suspended", r.Failed = "failed", r))(qe || {});
class pr extends K {
  /**
   * Constructs a new `DefaultConnection` instance.
   * @param ably The Ably Realtime client.
   * @param logger The logger to use.
   */
  constructor(e, t) {
    super(), this._status = "initialized", this._logger = t, this._status = this._mapAblyStatusToChat(e.connection.state), this._error = e.connection.errorReason, this._connection = e.connection, this._connection.on((n) => {
      const s = this._mapAblyStatusToChat(n.current);
      if (s === this._status)
        return;
      const c = {
        current: s,
        previous: this._status,
        error: n.reason,
        retryIn: n.retryIn
      };
      if (s === "disconnected" && !this._transientTimeout) {
        this._transientTimeout = setTimeout(() => {
          this._onTransientDisconnectTimeout(c);
        }, yr);
        return;
      }
      if (this._transientTimeout) {
        if (s === "connecting" || s === "disconnected") {
          this._logger.debug("ignoring transient state due to transient disconnect timeout", c);
          return;
        }
        this._cancelTransientDisconnectTimeout();
      }
      this._applyStatusChange(c);
    });
  }
  /**
   * @inheritdoc
   */
  get status() {
    return this._status;
  }
  /**
   * @inheritdoc
   */
  get error() {
    return this._error;
  }
  /**
   * @inheritdoc
   */
  onStatusChange(e) {
    return this.on(e), {
      off: () => {
        this.off(e);
      }
    };
  }
  /**
   * @inheritdoc
   */
  offAllStatusChange() {
    this.off();
  }
  _applyStatusChange(e) {
    this._status = e.current, this._error = e.error, this._logger.info("Connection state changed", e), this.emit(e.current, e);
  }
  _mapAblyStatusToChat(e) {
    switch (e) {
      case "closing":
      case "closed":
        return "failed";
      default:
        return e;
    }
  }
  /**
   * Handles a transient disconnect timeout.
   *
   * @param statusChange The change in status.
   */
  _onTransientDisconnectTimeout(e) {
    this._logger.debug("transient disconnect timeout reached"), this._cancelTransientDisconnectTimeout(), this._applyStatusChange({
      ...e,
      current: this._mapAblyStatusToChat(this._connection.state)
    });
  }
  /**
   * Cancels the transient disconnect timeout.
   */
  _cancelTransientDisconnectTimeout() {
    this._transientTimeout && (clearTimeout(this._transientTimeout), this._transientTimeout = void 0);
  }
}
var Rt = Object.prototype.hasOwnProperty;
function wt(r, e, t) {
  for (t of r.keys())
    if (ue(t, e)) return t;
}
function ue(r, e) {
  var t, n, s;
  if (r === e) return !0;
  if (r && e && (t = r.constructor) === e.constructor) {
    if (t === Date) return r.getTime() === e.getTime();
    if (t === RegExp) return r.toString() === e.toString();
    if (t === Array) {
      if ((n = r.length) === e.length)
        for (; n-- && ue(r[n], e[n]); ) ;
      return n === -1;
    }
    if (t === Set) {
      if (r.size !== e.size)
        return !1;
      for (n of r)
        if (s = n, s && typeof s == "object" && (s = wt(e, s), !s) || !e.has(s)) return !1;
      return !0;
    }
    if (t === Map) {
      if (r.size !== e.size)
        return !1;
      for (n of r)
        if (s = n[0], s && typeof s == "object" && (s = wt(e, s), !s) || !ue(n[1], e.get(s)))
          return !1;
      return !0;
    }
    if (t === ArrayBuffer)
      r = new Uint8Array(r), e = new Uint8Array(e);
    else if (t === DataView) {
      if ((n = r.byteLength) === e.byteLength)
        for (; n-- && r.getInt8(n) === e.getInt8(n); ) ;
      return n === -1;
    }
    if (ArrayBuffer.isView(r)) {
      if ((n = r.byteLength) === e.byteLength)
        for (; n-- && r[n] === e[n]; ) ;
      return n === -1;
    }
    if (!t || typeof r == "object") {
      n = 0;
      for (t in r)
        if (Rt.call(r, t) && ++n && !Rt.call(e, t) || !(t in e) || !ue(r[t], e[t])) return !1;
      return Object.keys(e).length === n;
    }
  }
  return r !== r && e !== e;
}
var Y = /* @__PURE__ */ ((r) => (r.Created = "message.created", r.Updated = "message.updated", r.Deleted = "message.deleted", r))(Y || {}), Dt = /* @__PURE__ */ ((r) => (r.ChatMessage = "chat.message", r))(Dt || {}), j = /* @__PURE__ */ ((r) => (r.MessageCreate = "message.create", r.MessageUpdate = "message.update", r.MessageDelete = "message.delete", r.MessageAnnotationCreate = "annotation.create", r.MessageAnnotationDelete = "annotation.delete", r.MessageMetaOccupancy = "meta.occupancy", r))(j || {}), br = /* @__PURE__ */ ((r) => (r.Enter = "enter", r.Leave = "leave", r.Update = "update", r.Present = "present", r))(br || {}), Pt = /* @__PURE__ */ ((r) => (r.Changed = "typing.changed", r))(Pt || {}), Ce = /* @__PURE__ */ ((r) => (r.Reaction = "roomReaction", r))(Ce || {});
class J {
  constructor(e, t, n, s, c, o, d, y, l, h, _) {
    this.serial = e, this.clientId = t, this.roomId = n, this.text = s, this.metadata = c, this.headers = o, this.action = d, this.version = y, this.createdAt = l, this.timestamp = h, this.operation = _, Object.freeze(this);
  }
  get isUpdated() {
    return this.action === j.MessageUpdate;
  }
  get isDeleted() {
    return this.action === j.MessageDelete;
  }
  get updatedBy() {
    var e;
    return this.isUpdated ? (e = this.operation) == null ? void 0 : e.clientId : void 0;
  }
  get deletedBy() {
    var e;
    return this.isDeleted ? (e = this.operation) == null ? void 0 : e.clientId : void 0;
  }
  get updatedAt() {
    return this.isUpdated ? this.timestamp : void 0;
  }
  get deletedAt() {
    return this.isDeleted ? this.timestamp : void 0;
  }
  isOlderVersionOf(e) {
    return this.equal(e) ? this.version < e.version : !1;
  }
  isNewerVersionOf(e) {
    return this.equal(e) ? this.version > e.version : !1;
  }
  isSameVersionAs(e) {
    return this.equal(e) ? this.version === e.version : !1;
  }
  before(e) {
    return this.serial < e.serial;
  }
  after(e) {
    return this.serial > e.serial;
  }
  equal(e) {
    return this.serial === e.serial;
  }
  isSameAs(e) {
    return this.equal(e);
  }
  with(e) {
    if (e.type === Y.Created)
      throw new pt("cannot apply a created event to a message", 4e4, 400);
    if (e.message.serial !== this.serial)
      throw new pt("cannot apply event for a different message", 4e4, 400);
    return this.version >= e.message.version ? this : e.message;
  }
  copy(e = {}) {
    return J._clone(this, e);
  }
  // Clone a message, optionally replace the given fields
  static _clone(e, t) {
    return new J(
      (t == null ? void 0 : t.serial) ?? e.serial,
      (t == null ? void 0 : t.clientId) ?? e.clientId,
      (t == null ? void 0 : t.roomId) ?? e.roomId,
      (t == null ? void 0 : t.text) ?? e.text,
      (t == null ? void 0 : t.metadata) ?? structuredClone(e.metadata),
      (t == null ? void 0 : t.headers) ?? structuredClone(e.headers),
      (t == null ? void 0 : t.action) ?? e.action,
      (t == null ? void 0 : t.version) ?? e.version,
      (t == null ? void 0 : t.createdAt) ?? e.createdAt,
      (t == null ? void 0 : t.timestamp) ?? e.timestamp,
      (t == null ? void 0 : t.operation) ?? structuredClone(e.operation)
    );
  }
}
const Ue = (r) => `${r}::$chat::$chatMessages`, me = () => new K();
var v = /* @__PURE__ */ ((r) => (r[r.MessageRejectedByBeforePublishRule = 42211] = "MessageRejectedByBeforePublishRule", r[r.MessageRejectedByModeration = 42213] = "MessageRejectedByModeration", r[r.MessagesAttachmentFailed = 102001] = "MessagesAttachmentFailed", r[r.PresenceAttachmentFailed = 102002] = "PresenceAttachmentFailed", r[r.ReactionsAttachmentFailed = 102003] = "ReactionsAttachmentFailed", r[r.OccupancyAttachmentFailed = 102004] = "OccupancyAttachmentFailed", r[r.TypingAttachmentFailed = 102005] = "TypingAttachmentFailed", r[r.MessagesDetachmentFailed = 102050] = "MessagesDetachmentFailed", r[r.PresenceDetachmentFailed = 102051] = "PresenceDetachmentFailed", r[r.ReactionsDetachmentFailed = 102052] = "ReactionsDetachmentFailed", r[r.OccupancyDetachmentFailed = 102053] = "OccupancyDetachmentFailed", r[r.TypingDetachmentFailed = 102054] = "TypingDetachmentFailed", r[r.RoomDiscontinuity = 102100] = "RoomDiscontinuity", r[r.RoomInFailedState = 102101] = "RoomInFailedState", r[r.RoomIsReleasing = 102102] = "RoomIsReleasing", r[r.RoomIsReleased = 102103] = "RoomIsReleased", r[r.PreviousOperationFailed = 102104] = "PreviousOperationFailed", r[r.RoomLifecycleError = 102105] = "RoomLifecycleError", r[r.RoomReleasedBeforeOperationCompleted = 102106] = "RoomReleasedBeforeOperationCompleted", r))(v || {});
const Ot = (r, e) => r.code === e;
function Rr(r, e) {
  const t = e;
  if (!r)
    throw new f.ErrorInfo("received incoming message without roomId", 5e4, 500);
  if (!t.data)
    throw new f.ErrorInfo("received incoming message without data", 5e4, 500);
  if (!t.clientId)
    throw new f.ErrorInfo("received incoming message without clientId", 5e4, 500);
  if (t.data.text === void 0)
    throw new f.ErrorInfo("received incoming message without text", 5e4, 500);
  if (!t.extras)
    throw new f.ErrorInfo("received incoming message without extras", 5e4, 500);
  if (!t.serial)
    throw new f.ErrorInfo("received incoming message without serial", 5e4, 500);
  if (!t.version)
    throw new f.ErrorInfo("received incoming message without version", 5e4, 500);
  if (!t.createdAt)
    throw new f.ErrorInfo("received incoming message without createdAt", 5e4, 500);
  if (!t.timestamp)
    throw new f.ErrorInfo("received incoming message without timestamp", 5e4, 500);
  switch (t.action) {
    case j.MessageCreate:
    case j.MessageUpdate:
    case j.MessageDelete:
      break;
    default:
      throw new f.ErrorInfo(`received incoming message with unhandled action; ${t.action}`, 5e4, 500);
  }
  return new J(
    t.serial,
    t.clientId,
    r,
    t.data.text,
    t.data.metadata ?? {},
    t.extras.headers ?? {},
    t.action,
    t.version,
    new Date(t.createdAt),
    new Date(t.timestamp),
    t.operation
  );
}
const wr = /* @__PURE__ */ new Map([
  [j.MessageCreate, Y.Created],
  [j.MessageUpdate, Y.Updated],
  [j.MessageDelete, Y.Deleted]
]);
var je = /* @__PURE__ */ ((r) => (r.OldestFirst = "oldestFirst", r.NewestFirst = "newestFirst", r))(je || {});
class vr extends K {
  /**
   * Constructs a new `DefaultMessages` instance.
   * @param roomId The unique identifier of the room.
   * @param channelManager An instance of the ChannelManager.
   * @param chatApi An instance of the ChatApi.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s, c) {
    super(), this._discontinuityEmitter = me(), this._roomId = e, this._channel = this._makeChannel(e, t), this._chatApi = n, this._clientId = s, this._logger = c, this._listenerSubscriptionPoints = /* @__PURE__ */ new Map();
  }
  /**
   * Creates the realtime channel for messages.
   */
  _makeChannel(e, t) {
    const n = t.get(Ue(e));
    return n.subscribe([Dt.ChatMessage], this._processEvent.bind(this)), n.on("attached", (s) => {
      this._handleAttach(s.resumed);
    }), n.on("update", (s) => {
      s.current === "attached" && s.previous === "attached" && this._handleAttach(s.resumed);
    }), n;
  }
  /**
   * @inheritdoc Messages
   */
  async _getBeforeSubscriptionStart(e, t) {
    this._logger.trace("DefaultSubscriptionManager.getBeforeSubscriptionStart();");
    const n = this._listenerSubscriptionPoints.get(e);
    if (n === void 0)
      throw this._logger.error(
        "DefaultSubscriptionManager.getBeforeSubscriptionStart(); listener has not been subscribed yet"
      ), new f.ErrorInfo(
        "cannot query history; listener has not been subscribed yet",
        4e4,
        400
      );
    const s = await n;
    return this._chatApi.getMessages(this._roomId, {
      ...t,
      orderBy: "newestFirst",
      ...s
    });
  }
  /**
   * Handle the case where the channel experiences a detach and reattaches.
   */
  _handleAttach(e) {
    if (this._logger.trace("DefaultSubscriptionManager.handleAttach();"), e) return;
    const t = this._subscribeAtChannelAttach();
    for (const [n] of this._listenerSubscriptionPoints.entries())
      this._listenerSubscriptionPoints.set(n, t);
  }
  /**
   * Create a promise that resolves with the attachSerial of the channel or the serial of the latest message.
   */
  async _resolveSubscriptionStart() {
    const e = this._getChannelProperties();
    if (e.state === "attached") {
      if (e.properties.channelSerial)
        return { fromSerial: e.properties.channelSerial };
      throw this._logger.error("DefaultSubscriptionManager.handleAttach(); channelSerial is undefined"), new f.ErrorInfo("channel is attached, but channelSerial is not defined", 4e4, 400);
    }
    return this._subscribeAtChannelAttach();
  }
  _getChannelProperties() {
    return this._channel;
  }
  async _subscribeAtChannelAttach() {
    const e = this._getChannelProperties();
    return new Promise((t, n) => {
      e.state === "attached" && (this._logger.debug("Messages._subscribeAtChannelAttach(); channel is attached already, using attachSerial", {
        attachSerial: e.properties.attachSerial
      }), e.properties.attachSerial ? t({ fromSerial: e.properties.attachSerial }) : (this._logger.error("DefaultSubscriptionManager.handleAttach(); attachSerial is undefined"), n(
        new f.ErrorInfo("channel is attached, but attachSerial is not defined", 4e4, 400)
      ))), e.once("attached", () => {
        this._logger.debug("Messages._subscribeAtChannelAttach(); channel is now attached, using attachSerial", {
          attachSerial: e.properties.attachSerial
        }), e.properties.attachSerial ? t({ fromSerial: e.properties.attachSerial }) : (this._logger.error("DefaultSubscriptionManager.handleAttach(); attachSerial is undefined"), n(
          new f.ErrorInfo("channel is attached, but attachSerial is not defined", 4e4, 400)
        ));
      });
    });
  }
  /**
   * @inheritdoc Messages
   */
  get channel() {
    return this._channel;
  }
  /**
   * @inheritdoc Messages
   */
  async get(e) {
    return this._logger.trace("Messages.query();"), this._chatApi.getMessages(this._roomId, e);
  }
  /**
   * @inheritdoc Messages
   */
  async send(e) {
    this._logger.trace("Messages.send();", { params: e });
    const { text: t, metadata: n, headers: s } = e, c = await this._chatApi.sendMessage(this._roomId, { text: t, headers: s, metadata: n });
    return new J(
      c.serial,
      this._clientId,
      this._roomId,
      t,
      n ?? {},
      s ?? {},
      j.MessageCreate,
      c.serial,
      new Date(c.createdAt),
      new Date(c.createdAt)
      // timestamp is the same as createdAt for new messages
    );
  }
  async update(e, t) {
    this._logger.trace("Messages.update();", { message: e, details: t });
    const n = await this._chatApi.updateMessage(this._roomId, e.serial, {
      message: {
        text: e.text,
        metadata: e.metadata,
        headers: e.headers
      },
      ...t
    }), s = new J(
      e.serial,
      e.clientId,
      this._roomId,
      e.text,
      e.metadata,
      e.headers,
      j.MessageUpdate,
      n.version,
      new Date(e.createdAt),
      new Date(n.timestamp),
      {
        clientId: this._clientId,
        description: t == null ? void 0 : t.description,
        metadata: t == null ? void 0 : t.metadata
      }
    );
    return this._logger.debug("Messages.update(); message update successfully", { message: e }), s;
  }
  /**
   * @inheritdoc Messages
   */
  async delete(e, t) {
    this._logger.trace("Messages.delete();", { params: t });
    const n = await this._chatApi.deleteMessage(this._roomId, e.serial, t), s = new J(
      e.serial,
      e.clientId,
      this._roomId,
      e.text,
      e.metadata,
      e.headers,
      j.MessageDelete,
      n.version,
      new Date(e.createdAt),
      new Date(n.timestamp),
      {
        clientId: this._clientId,
        description: t == null ? void 0 : t.description,
        metadata: t == null ? void 0 : t.metadata
      }
    );
    return this._logger.debug("Messages.delete(); message deleted successfully", { deletedMessage: s }), s;
  }
  /**
   * @inheritdoc Messages
   */
  subscribe(e) {
    this._logger.trace("Messages.subscribe();"), super.on([Y.Created, Y.Updated, Y.Deleted], e);
    const t = this._resolveSubscriptionStart();
    return t.catch(() => {
      this._logger.debug("Messages.subscribe(); subscription point was not resolved before the room was released", {
        roomId: this._roomId
      });
    }), this._listenerSubscriptionPoints.set(e, t), {
      unsubscribe: () => {
        this._listenerSubscriptionPoints.delete(e), this._logger.trace("Messages.unsubscribe();"), super.off(e);
      },
      getPreviousMessages: (n) => this._getBeforeSubscriptionStart(e, n)
    };
  }
  /**
   * @inheritdoc Messages
   */
  unsubscribeAll() {
    this._logger.trace("Messages.unsubscribeAll();"), super.off(), this._listenerSubscriptionPoints.clear();
  }
  _processEvent(e) {
    this._logger.trace("Messages._processEvent();", {
      channelEventMessage: e
    });
    const { action: t } = e, n = wr.get(t);
    if (!n) {
      this._logger.debug("Messages._processEvent(); received unknown message action", { action: t });
      return;
    }
    const s = this._parseNewMessage(e);
    s && this.emit(n, { type: n, message: s });
  }
  /**
   * Validate the realtime message and convert it to a chat message.
   */
  _parseNewMessage(e) {
    try {
      return Rr(this._roomId, e);
    } catch (t) {
      this._logger.error("failed to parse incoming message;", { channelEventMessage: e, error: t });
    }
  }
  /**
   * @inheritdoc HandlesDiscontinuity
   */
  discontinuityDetected(e) {
    this._logger.warn("Messages.discontinuityDetected();", { reason: e }), this._discontinuityEmitter.emit("discontinuity", e);
  }
  /**
   * @inheritdoc EmitsDiscontinuities
   */
  onDiscontinuity(e) {
    return this._logger.trace("Messages.onDiscontinuity();"), this._discontinuityEmitter.on(e), {
      off: () => {
        this._discontinuityEmitter.off(e);
      }
    };
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get attachmentErrorCode() {
    return v.MessagesAttachmentFailed;
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get detachmentErrorCode() {
    return v.MessagesDetachmentFailed;
  }
}
class Ir {
  constructor(e, t) {
    this._apiProtocolVersion = 3, this._realtime = e, this._logger = t;
  }
  async getMessages(e, t) {
    e = encodeURIComponent(e);
    const n = { ...t };
    if (t.orderBy)
      switch (t.orderBy) {
        case je.NewestFirst: {
          n.direction = "backwards";
          break;
        }
        case je.OldestFirst: {
          n.direction = "forwards";
          break;
        }
        default:
          throw new f.ErrorInfo(`invalid orderBy value: ${t.orderBy}`, 4e4, 400);
      }
    const s = await this._makeAuthorizedPaginatedRequest(`/chat/v2/rooms/${e}/messages`, n);
    return this._recursivePaginateMessages(s);
  }
  _recursivePaginateMessages(e) {
    const t = (s) => {
      const c = s.metadata, o = s.headers;
      return new J(
        s.serial,
        s.clientId,
        s.roomId,
        s.text,
        c ?? {},
        o ?? {},
        s.action,
        s.version,
        s.createdAt ? new Date(s.createdAt) : new Date(s.timestamp),
        new Date(s.timestamp),
        s.operation
      );
    }, n = {};
    return n.items = e.items.map((s) => t(s)), n.next = () => e.next().then((s) => s ? this._recursivePaginateMessages(s) : null), n.first = () => e.first().then((s) => this._recursivePaginateMessages(s)), n.current = () => e.current().then((s) => this._recursivePaginateMessages(s)), { ...e, ...n };
  }
  async deleteMessage(e, t, n) {
    const s = {
      description: n == null ? void 0 : n.description,
      metadata: n == null ? void 0 : n.metadata
    };
    return t = encodeURIComponent(t), e = encodeURIComponent(e), this._makeAuthorizedRequest(
      `/chat/v2/rooms/${e}/messages/${t}/delete`,
      "POST",
      s,
      {}
    );
  }
  async sendMessage(e, t) {
    const n = { text: t.text };
    return t.metadata && (n.metadata = t.metadata), t.headers && (n.headers = t.headers), e = encodeURIComponent(e), this._makeAuthorizedRequest(`/chat/v2/rooms/${e}/messages`, "POST", n);
  }
  async updateMessage(e, t, n) {
    const s = encodeURIComponent(t);
    return e = encodeURIComponent(e), this._makeAuthorizedRequest(
      `/chat/v2/rooms/${e}/messages/${s}`,
      "PUT",
      n
    );
  }
  async getOccupancy(e) {
    return e = encodeURIComponent(e), this._makeAuthorizedRequest(`/chat/v1/rooms/${e}/occupancy`, "GET");
  }
  async _makeAuthorizedRequest(e, t, n, s) {
    const c = await this._realtime.request(t, e, this._apiProtocolVersion, s, n);
    if (!c.success)
      throw this._logger.error("ChatApi._makeAuthorizedRequest(); failed to make request", {
        url: e,
        statusCode: c.statusCode,
        errorCode: c.errorCode,
        errorMessage: c.errorMessage
      }), new f.ErrorInfo(c.errorMessage, c.errorCode, c.statusCode);
    return c.items[0];
  }
  async _makeAuthorizedPaginatedRequest(e, t, n) {
    const s = await this._realtime.request("GET", e, this._apiProtocolVersion, t, n);
    if (!s.success)
      throw this._logger.error("ChatApi._makeAuthorizedPaginatedRequest(); failed to make request", {
        url: e,
        statusCode: s.statusCode,
        errorCode: s.errorCode,
        errorMessage: s.errorMessage
      }), new f.ErrorInfo(s.errorMessage, s.errorCode, s.statusCode);
    return s;
  }
}
const Cr = () => Math.random().toString(36).slice(2);
var Ie = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Sr(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var ge = { exports: {} };
ge.exports;
var vt;
function Er() {
  return vt || (vt = 1, function(r, e) {
    var t = 200, n = "__lodash_hash_undefined__", s = 9007199254740991, c = "[object Arguments]", o = "[object Array]", d = "[object Boolean]", y = "[object Date]", l = "[object Error]", h = "[object Function]", _ = "[object GeneratorFunction]", C = "[object Map]", E = "[object Number]", S = "[object Object]", p = "[object Promise]", b = "[object RegExp]", R = "[object Set]", T = "[object String]", L = "[object Symbol]", B = "[object WeakMap]", O = "[object ArrayBuffer]", U = "[object DataView]", z = "[object Float32Array]", G = "[object Float64Array]", D = "[object Int8Array]", Z = "[object Int16Array]", Be = "[object Int32Array]", ze = "[object Uint8Array]", We = "[object Uint8ClampedArray]", Ge = "[object Uint16Array]", Ve = "[object Uint32Array]", Nt = /[\\^$.*+?()[\]{}|]/g, qt = /\w*$/, jt = /^\[object .+?Constructor\]$/, kt = /^(?:0|[1-9]\d*)$/, I = {};
    I[c] = I[o] = I[O] = I[U] = I[d] = I[y] = I[z] = I[G] = I[D] = I[Z] = I[Be] = I[C] = I[E] = I[S] = I[b] = I[R] = I[T] = I[L] = I[ze] = I[We] = I[Ge] = I[Ve] = !0, I[l] = I[h] = I[B] = !1;
    var Ut = typeof Ie == "object" && Ie && Ie.Object === Object && Ie, $t = typeof self == "object" && self && self.Object === Object && self, V = Ut || $t || Function("return this")(), He = e && !e.nodeType && e, Qe = He && !0 && r && !r.nodeType && r, Bt = Qe && Qe.exports === He;
    function zt(i, a) {
      return i.set(a[0], a[1]), i;
    }
    function Wt(i, a) {
      return i.add(a), i;
    }
    function Gt(i, a) {
      for (var u = -1, g = i ? i.length : 0; ++u < g && a(i[u], u, i) !== !1; )
        ;
      return i;
    }
    function Vt(i, a) {
      for (var u = -1, g = a.length, A = i.length; ++u < g; )
        i[A + u] = a[u];
      return i;
    }
    function Ke(i, a, u, g) {
      for (var A = -1, x = i ? i.length : 0; ++A < x; )
        u = a(u, i[A], A, i);
      return u;
    }
    function Ht(i, a) {
      for (var u = -1, g = Array(i); ++u < i; )
        g[u] = a(u);
      return g;
    }
    function Qt(i, a) {
      return i == null ? void 0 : i[a];
    }
    function Xe(i) {
      var a = !1;
      if (i != null && typeof i.toString != "function")
        try {
          a = !!(i + "");
        } catch {
        }
      return a;
    }
    function Ye(i) {
      var a = -1, u = Array(i.size);
      return i.forEach(function(g, A) {
        u[++a] = [A, g];
      }), u;
    }
    function Ee(i, a) {
      return function(u) {
        return i(a(u));
      };
    }
    function Je(i) {
      var a = -1, u = Array(i.size);
      return i.forEach(function(g) {
        u[++a] = g;
      }), u;
    }
    var Kt = Array.prototype, Xt = Function.prototype, ye = Object.prototype, Te = V["__core-js_shared__"], Ze = function() {
      var i = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "");
      return i ? "Symbol(src)_1." + i : "";
    }(), et = Xt.toString, X = ye.hasOwnProperty, pe = ye.toString, Yt = RegExp(
      "^" + et.call(X).replace(Nt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), tt = Bt ? V.Buffer : void 0, nt = V.Symbol, rt = V.Uint8Array, Jt = Ee(Object.getPrototypeOf, Object), Zt = Object.create, en = ye.propertyIsEnumerable, tn = Kt.splice, it = Object.getOwnPropertySymbols, nn = tt ? tt.isBuffer : void 0, rn = Ee(Object.keys, Object), Me = ae(V, "DataView"), le = ae(V, "Map"), Ae = ae(V, "Promise"), De = ae(V, "Set"), Pe = ae(V, "WeakMap"), de = ae(Object, "create"), sn = ne(Me), on = ne(le), an = ne(Ae), cn = ne(De), un = ne(Pe), st = nt ? nt.prototype : void 0, ot = st ? st.valueOf : void 0;
    function ee(i) {
      var a = -1, u = i ? i.length : 0;
      for (this.clear(); ++a < u; ) {
        var g = i[a];
        this.set(g[0], g[1]);
      }
    }
    function hn() {
      this.__data__ = de ? de(null) : {};
    }
    function ln(i) {
      return this.has(i) && delete this.__data__[i];
    }
    function dn(i) {
      var a = this.__data__;
      if (de) {
        var u = a[i];
        return u === n ? void 0 : u;
      }
      return X.call(a, i) ? a[i] : void 0;
    }
    function gn(i) {
      var a = this.__data__;
      return de ? a[i] !== void 0 : X.call(a, i);
    }
    function fn(i, a) {
      var u = this.__data__;
      return u[i] = de && a === void 0 ? n : a, this;
    }
    ee.prototype.clear = hn, ee.prototype.delete = ln, ee.prototype.get = dn, ee.prototype.has = gn, ee.prototype.set = fn;
    function H(i) {
      var a = -1, u = i ? i.length : 0;
      for (this.clear(); ++a < u; ) {
        var g = i[a];
        this.set(g[0], g[1]);
      }
    }
    function _n() {
      this.__data__ = [];
    }
    function mn(i) {
      var a = this.__data__, u = be(a, i);
      if (u < 0)
        return !1;
      var g = a.length - 1;
      return u == g ? a.pop() : tn.call(a, u, 1), !0;
    }
    function yn(i) {
      var a = this.__data__, u = be(a, i);
      return u < 0 ? void 0 : a[u][1];
    }
    function pn(i) {
      return be(this.__data__, i) > -1;
    }
    function bn(i, a) {
      var u = this.__data__, g = be(u, i);
      return g < 0 ? u.push([i, a]) : u[g][1] = a, this;
    }
    H.prototype.clear = _n, H.prototype.delete = mn, H.prototype.get = yn, H.prototype.has = pn, H.prototype.set = bn;
    function se(i) {
      var a = -1, u = i ? i.length : 0;
      for (this.clear(); ++a < u; ) {
        var g = i[a];
        this.set(g[0], g[1]);
      }
    }
    function Rn() {
      this.__data__ = {
        hash: new ee(),
        map: new (le || H)(),
        string: new ee()
      };
    }
    function wn(i) {
      return Re(this, i).delete(i);
    }
    function vn(i) {
      return Re(this, i).get(i);
    }
    function In(i) {
      return Re(this, i).has(i);
    }
    function Cn(i, a) {
      return Re(this, i).set(i, a), this;
    }
    se.prototype.clear = Rn, se.prototype.delete = wn, se.prototype.get = vn, se.prototype.has = In, se.prototype.set = Cn;
    function oe(i) {
      this.__data__ = new H(i);
    }
    function Sn() {
      this.__data__ = new H();
    }
    function En(i) {
      return this.__data__.delete(i);
    }
    function Tn(i) {
      return this.__data__.get(i);
    }
    function Mn(i) {
      return this.__data__.has(i);
    }
    function An(i, a) {
      var u = this.__data__;
      if (u instanceof H) {
        var g = u.__data__;
        if (!le || g.length < t - 1)
          return g.push([i, a]), this;
        u = this.__data__ = new se(g);
      }
      return u.set(i, a), this;
    }
    oe.prototype.clear = Sn, oe.prototype.delete = En, oe.prototype.get = Tn, oe.prototype.has = Mn, oe.prototype.set = An;
    function Dn(i, a) {
      var u = xe(i) || er(i) ? Ht(i.length, String) : [], g = u.length, A = !!g;
      for (var x in i)
        X.call(i, x) && !(A && (x == "length" || Xn(x, g))) && u.push(x);
      return u;
    }
    function at(i, a, u) {
      var g = i[a];
      (!(X.call(i, a) && lt(g, u)) || u === void 0 && !(a in i)) && (i[a] = u);
    }
    function be(i, a) {
      for (var u = i.length; u--; )
        if (lt(i[u][0], a))
          return u;
      return -1;
    }
    function Pn(i, a) {
      return i && ct(a, Fe(a), i);
    }
    function Oe(i, a, u, g, A, x, Q) {
      var F;
      if (g && (F = x ? g(i, A, x, Q) : g(i)), F !== void 0)
        return F;
      if (!we(i))
        return i;
      var ft = xe(i);
      if (ft) {
        if (F = Hn(i), !a)
          return Wn(i, F);
      } else {
        var ce = te(i), _t = ce == h || ce == _;
        if (nr(i))
          return qn(i, a);
        if (ce == S || ce == c || _t && !x) {
          if (Xe(i))
            return x ? i : {};
          if (F = Qn(_t ? {} : i), !a)
            return Gn(i, Pn(F, i));
        } else {
          if (!I[ce])
            return x ? i : {};
          F = Kn(i, ce, Oe, a);
        }
      }
      Q || (Q = new oe());
      var mt = Q.get(i);
      if (mt)
        return mt;
      if (Q.set(i, F), !ft)
        var yt = u ? Vn(i) : Fe(i);
      return Gt(yt || i, function(Ne, ve) {
        yt && (ve = Ne, Ne = i[ve]), at(F, ve, Oe(Ne, a, u, g, ve, i, Q));
      }), F;
    }
    function On(i) {
      return we(i) ? Zt(i) : {};
    }
    function Ln(i, a, u) {
      var g = a(i);
      return xe(i) ? g : Vt(g, u(i));
    }
    function xn(i) {
      return pe.call(i);
    }
    function Fn(i) {
      if (!we(i) || Jn(i))
        return !1;
      var a = gt(i) || Xe(i) ? Yt : jt;
      return a.test(ne(i));
    }
    function Nn(i) {
      if (!ht(i))
        return rn(i);
      var a = [];
      for (var u in Object(i))
        X.call(i, u) && u != "constructor" && a.push(u);
      return a;
    }
    function qn(i, a) {
      if (a)
        return i.slice();
      var u = new i.constructor(i.length);
      return i.copy(u), u;
    }
    function Le(i) {
      var a = new i.constructor(i.byteLength);
      return new rt(a).set(new rt(i)), a;
    }
    function jn(i, a) {
      var u = a ? Le(i.buffer) : i.buffer;
      return new i.constructor(u, i.byteOffset, i.byteLength);
    }
    function kn(i, a, u) {
      var g = a ? u(Ye(i), !0) : Ye(i);
      return Ke(g, zt, new i.constructor());
    }
    function Un(i) {
      var a = new i.constructor(i.source, qt.exec(i));
      return a.lastIndex = i.lastIndex, a;
    }
    function $n(i, a, u) {
      var g = a ? u(Je(i), !0) : Je(i);
      return Ke(g, Wt, new i.constructor());
    }
    function Bn(i) {
      return ot ? Object(ot.call(i)) : {};
    }
    function zn(i, a) {
      var u = a ? Le(i.buffer) : i.buffer;
      return new i.constructor(u, i.byteOffset, i.length);
    }
    function Wn(i, a) {
      var u = -1, g = i.length;
      for (a || (a = Array(g)); ++u < g; )
        a[u] = i[u];
      return a;
    }
    function ct(i, a, u, g) {
      u || (u = {});
      for (var A = -1, x = a.length; ++A < x; ) {
        var Q = a[A], F = void 0;
        at(u, Q, F === void 0 ? i[Q] : F);
      }
      return u;
    }
    function Gn(i, a) {
      return ct(i, ut(i), a);
    }
    function Vn(i) {
      return Ln(i, Fe, ut);
    }
    function Re(i, a) {
      var u = i.__data__;
      return Yn(a) ? u[typeof a == "string" ? "string" : "hash"] : u.map;
    }
    function ae(i, a) {
      var u = Qt(i, a);
      return Fn(u) ? u : void 0;
    }
    var ut = it ? Ee(it, Object) : sr, te = xn;
    (Me && te(new Me(new ArrayBuffer(1))) != U || le && te(new le()) != C || Ae && te(Ae.resolve()) != p || De && te(new De()) != R || Pe && te(new Pe()) != B) && (te = function(i) {
      var a = pe.call(i), u = a == S ? i.constructor : void 0, g = u ? ne(u) : void 0;
      if (g)
        switch (g) {
          case sn:
            return U;
          case on:
            return C;
          case an:
            return p;
          case cn:
            return R;
          case un:
            return B;
        }
      return a;
    });
    function Hn(i) {
      var a = i.length, u = i.constructor(a);
      return a && typeof i[0] == "string" && X.call(i, "index") && (u.index = i.index, u.input = i.input), u;
    }
    function Qn(i) {
      return typeof i.constructor == "function" && !ht(i) ? On(Jt(i)) : {};
    }
    function Kn(i, a, u, g) {
      var A = i.constructor;
      switch (a) {
        case O:
          return Le(i);
        case d:
        case y:
          return new A(+i);
        case U:
          return jn(i, g);
        case z:
        case G:
        case D:
        case Z:
        case Be:
        case ze:
        case We:
        case Ge:
        case Ve:
          return zn(i, g);
        case C:
          return kn(i, g, u);
        case E:
        case T:
          return new A(i);
        case b:
          return Un(i);
        case R:
          return $n(i, g, u);
        case L:
          return Bn(i);
      }
    }
    function Xn(i, a) {
      return a = a ?? s, !!a && (typeof i == "number" || kt.test(i)) && i > -1 && i % 1 == 0 && i < a;
    }
    function Yn(i) {
      var a = typeof i;
      return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? i !== "__proto__" : i === null;
    }
    function Jn(i) {
      return !!Ze && Ze in i;
    }
    function ht(i) {
      var a = i && i.constructor, u = typeof a == "function" && a.prototype || ye;
      return i === u;
    }
    function ne(i) {
      if (i != null) {
        try {
          return et.call(i);
        } catch {
        }
        try {
          return i + "";
        } catch {
        }
      }
      return "";
    }
    function Zn(i) {
      return Oe(i, !0, !0);
    }
    function lt(i, a) {
      return i === a || i !== i && a !== a;
    }
    function er(i) {
      return tr(i) && X.call(i, "callee") && (!en.call(i, "callee") || pe.call(i) == c);
    }
    var xe = Array.isArray;
    function dt(i) {
      return i != null && rr(i.length) && !gt(i);
    }
    function tr(i) {
      return ir(i) && dt(i);
    }
    var nr = nn || or;
    function gt(i) {
      var a = we(i) ? pe.call(i) : "";
      return a == h || a == _;
    }
    function rr(i) {
      return typeof i == "number" && i > -1 && i % 1 == 0 && i <= s;
    }
    function we(i) {
      var a = typeof i;
      return !!i && (a == "object" || a == "function");
    }
    function ir(i) {
      return !!i && typeof i == "object";
    }
    function Fe(i) {
      return dt(i) ? Dn(i) : Nn(i);
    }
    function sr() {
      return [];
    }
    function or() {
      return !1;
    }
    r.exports = Zn;
  }(ge, ge.exports)), ge.exports;
}
var Tr = Er();
const Mr = /* @__PURE__ */ Sr(Tr), Se = "0.5.1", Ar = `chat-js/${Se}`, Dr = `chat-react/${Se}`, Pr = {
  params: { agent: Ar },
  attachOnSubscribe: !1
}, Or = {
  params: { agent: Dr },
  attachOnSubscribe: !1
};
class Lr {
  constructor(e, t, n) {
    this._registeredOptions = /* @__PURE__ */ new Map(), this._requestedChannels = /* @__PURE__ */ new Set(), t.trace("ChannelManager();", { isReact: n }), this._realtime = e, this._logger = t, this._isReact = n;
  }
  mergeOptions(e, t) {
    if (this._logger.trace("ChannelManager.registerOptions();", { channelName: e }), this._requestedChannels.has(e))
      throw this._logger.error("channel options cannot be modified after the channel has been requested", { channelName: e }), new f.ErrorInfo("channel options cannot be modified after the channel has been requested", 4e4, 400);
    const n = this._registeredOptions.get(e) ?? this._defaultChannelOptions();
    this._registeredOptions.set(e, t(n));
  }
  get(e) {
    return this._logger.trace("ChannelManager.get();", { channelName: e }), this._requestedChannels.add(e), this._realtime.channels.get(
      e,
      this._registeredOptions.get(e) ?? this._defaultChannelOptions()
    );
  }
  release(e) {
    this._logger.trace("ChannelManager.release();", { channelName: e }), this._requestedChannels.delete(e), this._registeredOptions.delete(e), this._realtime.channels.release(e);
  }
  _defaultChannelOptions() {
    return this._isReact ? Or : Pr;
  }
}
class fe extends K {
  /**
   * Constructs a new `DefaultOccupancy` instance.
   * @param roomId The unique identifier of the room.
   * @param channelManager An instance of the ChannelManager.
   * @param chatApi An instance of the ChatApi.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s) {
    super(), this._discontinuityEmitter = me(), this._roomId = e, this._channel = this._makeChannel(e, t), this._chatApi = n, this._logger = s;
  }
  /**
   * Creates the realtime channel for occupancy.
   */
  _makeChannel(e, t) {
    const n = t.get(fe.channelName(e));
    return n.subscribe(["[meta]occupancy"], this._internalOccupancyListener.bind(this)), n;
  }
  /**
   * @inheritdoc Occupancy
   */
  subscribe(e) {
    return this._logger.trace("Occupancy.subscribe();"), this.on(e), {
      unsubscribe: () => {
        this._logger.trace("Occupancy.unsubscribe();"), this.off(e);
      }
    };
  }
  /**
   * @inheritdoc Occupancy
   */
  unsubscribeAll() {
    this._logger.trace("Occupancy.unsubscribeAll();"), this.off();
  }
  /**
   * @inheritdoc Occupancy
   */
  async get() {
    return this._logger.trace("Occupancy.get();"), this._chatApi.getOccupancy(this._roomId);
  }
  /**
   * @inheritdoc Occupancy
   */
  get channel() {
    return this._channel;
  }
  /**
   * An internal listener that listens for occupancy events from the underlying channel and translates them into
   * occupancy events for the public API.
   */
  _internalOccupancyListener(e) {
    if (typeof e.data != "object") {
      this._logger.error("invalid occupancy event received; data is not an object", e);
      return;
    }
    const { metrics: t } = e.data;
    if (t === void 0) {
      this._logger.error("invalid occupancy event received; metrics is missing", e);
      return;
    }
    const { connections: n, presenceMembers: s } = t;
    if (n === void 0) {
      this._logger.error("invalid occupancy event received; connections is missing", e);
      return;
    }
    if (!Number.isInteger(n)) {
      this._logger.error("invalid occupancy event received; connections is not a number", e);
      return;
    }
    if (s === void 0) {
      this._logger.error("invalid occupancy event received; presenceMembers is missing", e);
      return;
    }
    if (!Number.isInteger(s)) {
      this._logger.error("invalid occupancy event received; presenceMembers is not a number", e);
      return;
    }
    this.emit("occupancy", {
      connections: n,
      presenceMembers: s
    });
  }
  onDiscontinuity(e) {
    return this._logger.trace("Occupancy.onDiscontinuity();"), this._discontinuityEmitter.on(e), {
      off: () => {
        this._discontinuityEmitter.off(e);
      }
    };
  }
  discontinuityDetected(e) {
    this._logger.warn("Occupancy.discontinuityDetected();", { reason: e }), this._discontinuityEmitter.emit("discontinuity", e);
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get attachmentErrorCode() {
    return v.OccupancyAttachmentFailed;
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get detachmentErrorCode() {
    return v.OccupancyDetachmentFailed;
  }
  /**
   * Merges the channel options for the room with the ones required for presence.
   *
   * @returns A function that merges the channel options for the room with the ones required for presence.
   */
  static channelOptionMerger() {
    return (e) => ({ ...e, params: { ...e.params, occupancy: "metrics" } });
  }
  /**
   * Returns the channel name for the presence channel.
   *
   * @param roomId The unique identifier of the room.
   * @returns The channel name for the presence channel.
   */
  static channelName(e) {
    return Ue(e);
  }
}
class _e extends K {
  /**
   * Constructs a new `DefaultPresence` instance.
   * @param roomId The unique identifier of the room.
   * @param channelManager The channel manager to use for creating the presence channel.
   * @param clientId The client ID, attached to presences messages as an identifier of the sender.
   * A channel can have multiple connections using the same clientId.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s) {
    super(), this._discontinuityEmitter = me(), this.subscribeToEvents = (c) => {
      var o;
      try {
        this.emit(c.action, {
          action: c.action,
          clientId: c.clientId,
          timestamp: c.timestamp,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          data: (o = c.data) == null ? void 0 : o.userCustomData
        });
      } catch (d) {
        throw this._logger.error("unable to handle presence event: not a valid presence event", { action: c.action }), new f.ErrorInfo(
          `unable to handle ${c.action} presence event: not a valid presence event`,
          5e4,
          500,
          d.message
        );
      }
    }, this._channel = this._makeChannel(e, t), this._clientId = n, this._logger = s;
  }
  /**
   * Creates the realtime channel for presence.
   */
  _makeChannel(e, t) {
    const n = t.get(_e.channelName(e));
    return n.presence.subscribe(this.subscribeToEvents.bind(this)), n;
  }
  /**
   * Get the underlying Ably realtime channel used for presence in this chat room.
   * @returns The realtime channel.
   */
  get channel() {
    return this._channel;
  }
  /**
   * @inheritDoc
   */
  async get(e) {
    return this._logger.trace("Presence.get()", { params: e }), (await this._channel.presence.get(e)).map((n) => {
      var s;
      return {
        clientId: n.clientId,
        action: n.action,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        data: (s = n.data) == null ? void 0 : s.userCustomData,
        updatedAt: n.timestamp,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        extras: n.extras
      };
    });
  }
  /**
   * @inheritDoc
   */
  async isUserPresent(e) {
    return (await this._channel.presence.get({ clientId: e })).length > 0;
  }
  /**
   * Method to join room presence, will emit an enter event to all subscribers. Repeat calls will trigger more enter events.
   * @param {PresenceData} data - The users data, a JSON serializable object that will be sent to all subscribers.
   * @returns {Promise<void>} or upon failure, the promise will be rejected with an {@link ErrorInfo} object which explains the error.
   */
  async enter(e) {
    this._logger.trace("Presence.enter()", { data: e });
    const t = {
      userCustomData: e
    };
    return this._channel.presence.enterClient(this._clientId, t);
  }
  /**
   * Method to update room presence, will emit an update event to all subscribers. If the user is not present, it will be treated as a join event.
   * @param {PresenceData} data - The users data, a JSON serializable object that will be sent to all subscribers.
   * @returns {Promise<void>} or upon failure, the promise will be rejected with an {@link ErrorInfo} object which explains the error.
   */
  async update(e) {
    this._logger.trace("Presence.update()", { data: e });
    const t = {
      userCustomData: e
    };
    return this._channel.presence.updateClient(this._clientId, t);
  }
  /**
   * Method to leave room presence, will emit a leave event to all subscribers. If the user is not present, it will be treated as a no-op.
   * @param {PresenceData} data - The users data, a JSON serializable object that will be sent to all subscribers.
   * @returns {Promise<void>} or upon failure, the promise will be rejected with an {@link ErrorInfo} object which explains the error.
   */
  async leave(e) {
    this._logger.trace("Presence.leave()", { data: e });
    const t = {
      userCustomData: e
    };
    return this._channel.presence.leaveClient(this._clientId, t);
  }
  subscribe(e, t) {
    if (this._logger.trace("Presence.subscribe(); listenerOrEvents", { listenerOrEvents: e }), !e && !t)
      throw this._logger.error("could not subscribe to presence; invalid arguments"), new f.ErrorInfo("could not subscribe listener: invalid arguments", 4e4, 400);
    return t ? (this.on(e, t), {
      unsubscribe: () => {
        this._logger.trace("Presence.unsubscribe();", { events: e }), this.off(t);
      }
    }) : (this.on(e), {
      unsubscribe: () => {
        this._logger.trace("Presence.unsubscribe();"), this.off(e);
      }
    });
  }
  /**
   * Unsubscribe all listeners from all presence events.
   */
  unsubscribeAll() {
    this._logger.trace("Presence.unsubscribeAll()"), this.off();
  }
  onDiscontinuity(e) {
    return this._logger.trace("Presence.onDiscontinuity();"), this._discontinuityEmitter.on(e), {
      off: () => {
        this._discontinuityEmitter.off(e);
      }
    };
  }
  discontinuityDetected(e) {
    this._logger.warn("Presence.discontinuityDetected();", { reason: e }), this._discontinuityEmitter.emit("discontinuity", e);
  }
  /**
   * @inheritDoc ContributesToRoomLifecycle
   */
  get attachmentErrorCode() {
    return v.PresenceAttachmentFailed;
  }
  /**
   * @inheritDoc
   */
  get detachmentErrorCode() {
    return v.PresenceDetachmentFailed;
  }
  /**
   * Merges the channel options for the room with the ones required for presence.
   *
   * @param roomOptions The room options to merge for.
   * @returns A function that merges the channel options for the room with the ones required for presence.
   */
  static channelOptionMerger(e) {
    return (t) => {
      var s, c;
      const n = ["PUBLISH", "SUBSCRIBE"];
      return (((s = e.presence) == null ? void 0 : s.enter) === void 0 || e.presence.enter) && n.push("PRESENCE"), (((c = e.presence) == null ? void 0 : c.subscribe) === void 0 || e.presence.subscribe) && n.push("PRESENCE_SUBSCRIBE"), { ...t, modes: n };
    };
  }
  /**
   * Returns the channel name for the presence channel.
   *
   * @param roomId The unique identifier of the room.
   * @returns The channel name for the presence channel.
   */
  static channelName(e) {
    return Ue(e);
  }
}
const xr = new Error("request for lock canceled");
var Fr = function(r, e, t, n) {
  function s(c) {
    return c instanceof t ? c : new t(function(o) {
      o(c);
    });
  }
  return new (t || (t = Promise))(function(c, o) {
    function d(h) {
      try {
        l(n.next(h));
      } catch (_) {
        o(_);
      }
    }
    function y(h) {
      try {
        l(n.throw(h));
      } catch (_) {
        o(_);
      }
    }
    function l(h) {
      h.done ? c(h.value) : s(h.value).then(d, y);
    }
    l((n = n.apply(r, e || [])).next());
  });
};
class Nr {
  constructor(e, t = xr) {
    this._value = e, this._cancelError = t, this._queue = [], this._weightedWaiters = [];
  }
  acquire(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return new Promise((n, s) => {
      const c = { resolve: n, reject: s, weight: e, priority: t }, o = Lt(this._queue, (d) => t <= d.priority);
      o === -1 && e <= this._value ? this._dispatchItem(c) : this._queue.splice(o + 1, 0, c);
    });
  }
  runExclusive(e) {
    return Fr(this, arguments, void 0, function* (t, n = 1, s = 0) {
      const [c, o] = yield this.acquire(n, s);
      try {
        return yield t(c);
      } finally {
        o();
      }
    });
  }
  waitForUnlock(e = 1, t = 0) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    return this._couldLockImmediately(e, t) ? Promise.resolve() : new Promise((n) => {
      this._weightedWaiters[e - 1] || (this._weightedWaiters[e - 1] = []), qr(this._weightedWaiters[e - 1], { resolve: n, priority: t });
    });
  }
  isLocked() {
    return this._value <= 0;
  }
  getValue() {
    return this._value;
  }
  setValue(e) {
    this._value = e, this._dispatchQueue();
  }
  release(e = 1) {
    if (e <= 0)
      throw new Error(`invalid weight ${e}: must be positive`);
    this._value += e, this._dispatchQueue();
  }
  cancel() {
    this._queue.forEach((e) => e.reject(this._cancelError)), this._queue = [];
  }
  _dispatchQueue() {
    for (this._drainUnlockWaiters(); this._queue.length > 0 && this._queue[0].weight <= this._value; )
      this._dispatchItem(this._queue.shift()), this._drainUnlockWaiters();
  }
  _dispatchItem(e) {
    const t = this._value;
    this._value -= e.weight, e.resolve([t, this._newReleaser(e.weight)]);
  }
  _newReleaser(e) {
    let t = !1;
    return () => {
      t || (t = !0, this.release(e));
    };
  }
  _drainUnlockWaiters() {
    if (this._queue.length === 0)
      for (let e = this._value; e > 0; e--) {
        const t = this._weightedWaiters[e - 1];
        t && (t.forEach((n) => n.resolve()), this._weightedWaiters[e - 1] = []);
      }
    else {
      const e = this._queue[0].priority;
      for (let t = this._value; t > 0; t--) {
        const n = this._weightedWaiters[t - 1];
        if (!n)
          continue;
        const s = n.findIndex((c) => c.priority <= e);
        (s === -1 ? n : n.splice(0, s)).forEach((c) => c.resolve());
      }
    }
  }
  _couldLockImmediately(e, t) {
    return (this._queue.length === 0 || this._queue[0].priority < t) && e <= this._value;
  }
}
function qr(r, e) {
  const t = Lt(r, (n) => e.priority <= n.priority);
  r.splice(t + 1, 0, e);
}
function Lt(r, e) {
  for (let t = r.length - 1; t >= 0; t--)
    if (e(r[t]))
      return t;
  return -1;
}
var jr = function(r, e, t, n) {
  function s(c) {
    return c instanceof t ? c : new t(function(o) {
      o(c);
    });
  }
  return new (t || (t = Promise))(function(c, o) {
    function d(h) {
      try {
        l(n.next(h));
      } catch (_) {
        o(_);
      }
    }
    function y(h) {
      try {
        l(n.throw(h));
      } catch (_) {
        o(_);
      }
    }
    function l(h) {
      h.done ? c(h.value) : s(h.value).then(d, y);
    }
    l((n = n.apply(r, e || [])).next());
  });
};
class kr {
  constructor(e) {
    this._semaphore = new Nr(1, e);
  }
  acquire() {
    return jr(this, arguments, void 0, function* (e = 0) {
      const [, t] = yield this._semaphore.acquire(1, e);
      return t;
    });
  }
  runExclusive(e, t = 0) {
    return this._semaphore.runExclusive(() => e(), 1, t);
  }
  isLocked() {
    return this._semaphore.isLocked();
  }
  waitForUnlock(e = 0) {
    return this._semaphore.waitForUnlock(1, e);
  }
  release() {
    this._semaphore.isLocked() && this._semaphore.release();
  }
  cancel() {
    return this._semaphore.cancel();
  }
}
var m = /* @__PURE__ */ ((r) => (r.Initializing = "initializing", r.Initialized = "initialized", r.Attaching = "attaching", r.Attached = "attached", r.Detaching = "detaching", r.Detached = "detached", r.Suspended = "suspended", r.Failed = "failed", r.Releasing = "releasing", r.Released = "released", r))(m || {});
class Ur extends K {
  /**
   * Constructs a new `DefaultStatus` instance.
   * @param roomId - The unique identifier for the room.
   * @param logger The logger to use.
   */
  constructor(e, t) {
    super(), this._status = "initialized", this._internalEmitter = new K(), this._roomId = e, this._logger = t, this._status = "initialized", this._error = void 0;
  }
  /**
   * @inheritdoc
   */
  get status() {
    return this._status;
  }
  /**
   * @inheritdoc
   */
  get error() {
    return this._error;
  }
  /**
   * @inheritdoc
   */
  onChange(e) {
    return this.on(e), {
      off: () => {
        this.off(e);
      }
    };
  }
  onChangeOnce(e) {
    this._internalEmitter.once(e);
  }
  /**
   * @inheritdoc
   */
  offAll() {
    this.off();
  }
  setStatus(e) {
    const t = {
      current: e.status,
      error: e.error,
      previous: this._status
    };
    this._status = t.current, this._error = t.error, this._logger.info("room status changed", { ...t, roomId: this._roomId }), this._internalEmitter.emit(t.current, t), this.emit(t.current, t);
  }
}
class $r {
  /**
   * Constructs a new `RoomLifecycleManager` instance.
   * @param lifecycle The room lifecycle that manages status.
   * @param contributors The features that contribute to the room status.
   * @param logger An instance of the Logger.
   * @param transientDetachTimeout The number of milliseconds to consider a detach to be "transient"
   */
  constructor(e, t, n, s) {
    this._mtx = new kr(), this._operationInProgress = !1, this._pendingDiscontinuityEvents = /* @__PURE__ */ new Map(), this._firstAttachesCompleted = /* @__PURE__ */ new Map(), this._releaseInProgress = !1, this._logger = n, this._contributors = t, this._transientDetachTimeouts = /* @__PURE__ */ new Map(), this._lifecycle = e, this._setupContributorListeners(s);
  }
  /**
   * Sets up listeners for each contributor to the room status.
   *
   * @param transientDetachTimeout The number of milliseconds to consider a detach to be "transient"
   */
  _setupContributorListeners(e) {
    for (const t of this._contributors)
      t.channel.on(["update"], (n) => {
        if (!this._firstAttachesCompleted.has(t)) {
          this._logger.debug("RoomLifecycleManager() on update; ignoring update event for feature as first attach", {
            channel: t.channel.name,
            change: n
          });
          return;
        }
        if (n.resumed) {
          this._logger.debug("RoomLifecycleManager(); update event received but was resume");
          return;
        }
        if (this._operationInProgress) {
          if (this._pendingDiscontinuityEvents.has(t)) {
            this._logger.debug("RoomLifecycleManager(); subsequent update event for feature received, ignoring", {
              channel: t.channel.name,
              change: n
            });
            return;
          }
          this._logger.debug(
            "RoomLifecycleManager(); queuing pending update event for feature as operation in progress",
            {
              channel: t.channel.name,
              change: n
            }
          ), this._pendingDiscontinuityEvents.set(t, n.reason);
          return;
        }
        this._logger.debug("RoomLifecycleManager(); update event received", {
          channel: t.channel.name,
          change: n
        }), t.discontinuityDetected(n.reason);
      }), t.channel.on(
        ["initialized", "attaching", "attached", "detaching", "detached", "suspended", "failed"],
        (n) => {
          if (this._operationInProgress) {
            this._logger.debug(
              "RoomLifecycleManager() on all events; ignoring contributor state change due to operation in progress",
              {
                channel: t.channel.name,
                current: n.current
              }
            ), n.current === m.Attached && !n.resumed && this._firstAttachesCompleted.has(t) && (this._logger.debug("RoomLifecycleManager(); resume failure detected", {
              channel: t.channel.name
            }), this._pendingDiscontinuityEvents.has(t) || this._pendingDiscontinuityEvents.set(t, n.reason));
            return;
          }
          if (n.current === m.Failed) {
            this._logger.debug("RoomLifecycleManager(); detected channel failure", {
              channel: t.channel.name
            }), this._clearAllTransientDetachTimeouts(), this._startLifecycleOperation(), this._lifecycle.setStatus({
              status: m.Failed,
              error: n.reason
            }), this._doChannelWindDown(t).catch((s) => {
              this._logger.error("RoomLifecycleManager(); failed to detach all channels following failure", {
                contributor: t.channel.name,
                error: s
              });
            });
            return;
          }
          if (n.current === m.Attached) {
            this._transientDetachTimeouts.has(t) && (this._logger.debug("RoomLifecycleManager(); detected transient detach", {
              channel: t.channel.name
            }), clearTimeout(this._transientDetachTimeouts.get(t)), this._transientDetachTimeouts.delete(t)), this._lifecycle.status !== m.Attached && this._contributors.every((s) => s.channel.state === "attached") && (this._logger.debug("RoomLifecycleManager(); all features attached, setting room status to attached"), this._lifecycle.setStatus({ status: m.Attached }));
            return;
          }
          if (n.current === m.Suspended) {
            this._logger.debug("RoomLifecycleManager(); detected channel suspension", {
              channel: t.channel.name
            }), this._onChannelSuspension(t, n.reason);
            return;
          }
          if (n.current === m.Attaching && !this._transientDetachTimeouts.has(t)) {
            this._logger.debug("RoomLifecycleManager(); detected channel detach", {
              channel: t.channel.name
            });
            const s = setTimeout(() => {
              this._lifecycle.setStatus({ status: m.Attaching, error: n.reason }), this._transientDetachTimeouts.delete(t), clearTimeout(s);
            }, e);
            this._transientDetachTimeouts.set(t, s);
            return;
          }
        }
      );
  }
  /**
   * _onChannelSuspension is called when a contributing channel enters the suspended state, which means
   * that the room is also suspended and we should wind-down channels until things recover.
   *
   * We transition the room status to the status of this contributor and provide the original
   * error that caused the detachment.
   *
   * @param contributor The contributor that has detached.
   * @param detachError The error that caused the detachment.
   */
  _onChannelSuspension(e, t) {
    this._logger.debug("RoomLifecycleManager._onChannelSuspension();", {
      channel: e.channel.name,
      error: t
    }), this._startLifecycleOperation(), this._clearAllTransientDetachTimeouts(), this._mtx.runExclusive(
      () => (this._logger.error("RoomLifecycleManager._onChannelSuspension(); setting room status to contributor status", {
        status: e.channel.state,
        error: t
      }), this._lifecycle.setStatus({
        status: e.channel.state,
        error: t
      }), this._doRetry(e)),
      2
      /* Internal */
    ).catch((n) => {
      this._logger.error("RoomLifecycleManager._onChannelSuspension(); unexpected error thrown", { error: n });
    });
  }
  /**
   * Given some contributor that has entered a suspended state:
   *
   * - Wind down any other channels
   * - Wait for our contributor to recover
   * - Attach everything else
   *
   * Repeat until either of the following happens:
   *
   * - Our contributor reattaches and we can attach everything else (repeat with the next contributor to break if necessary)
   * - The room enters a failed state
   *
   * @param contributor The contributor that has entered a suspended state.
   * @returns A promise that resolves when the room is attached, or the room enters a failed state.
   */
  async _doRetry(e) {
    const t = () => (this._logger.debug("RoomLifecycleManager.doAttachWithRetry();"), this._lifecycle.setStatus({ status: m.Attaching }), this._doAttach().then((n) => {
      var s;
      if (this._logger.debug("RoomLifecycleManager.doAttachWithRetry(); attach result", {
        status: n.status,
        error: n.error,
        failedFeature: (s = n.failedFeature) == null ? void 0 : s.channel.name
      }), n.status === m.Failed) {
        this._mtx.runExclusive(
          () => this._runDownChannelsOnFailedAttach().finally(() => {
            this._endLifecycleOperation();
          }),
          2
          /* Internal */
        );
        return;
      }
      if (n.status === m.Suspended) {
        const c = n.failedFeature;
        if (!c)
          throw new f.ErrorInfo("no failed feature in _doRetry", v.RoomLifecycleError, 500);
        return this._logger.debug("RoomLifecycleManager.doAttachWithRetry(); feature suspended, retrying attach", {
          feature: c.channel.name
        }), this._doRetry(c).catch();
      }
      this._endLifecycleOperation();
    }));
    this._logger.debug("RoomLifecycleManager._doRetry(); winding down channels except problem", {
      channel: e.channel.name
    });
    try {
      await this._doChannelWindDown(e).catch(() => {
        if (this._lifecycle.status === m.Failed)
          throw new Error("room is in a failed state");
        return new Promise((n) => {
          setTimeout(() => {
            n(this._doChannelWindDown(e));
          }, 250);
        });
      });
    } catch {
      this._endLifecycleOperation();
      return;
    }
    return e.channel.state === "attached" ? (this._logger.debug("RoomLifecycleManager._doRetry(); feature reattached, retrying attach"), t()) : new Promise((n) => {
      const s = (c) => {
        if (c.current === "attached") {
          e.channel.off(s), n();
          return;
        }
        if (c.current === "failed")
          throw e.channel.off(s), this._lifecycle.setStatus({ status: m.Failed, error: c.reason }), this._endLifecycleOperation(), c.reason ?? new f.ErrorInfo("unknown error in _doRetry", v.RoomLifecycleError, 500);
      };
      e.channel.on(s);
    }).then(() => (this._logger.debug("RoomLifecycleManager._doRetry(); feature reattached via listener, retrying attach"), t()));
  }
  /**
   * Clears all transient detach timeouts - used when some event supersedes the transient detach such
   * as a failed channel or suspension.
   */
  _clearAllTransientDetachTimeouts() {
    for (const e of this._transientDetachTimeouts.values())
      clearTimeout(e);
    this._transientDetachTimeouts.clear();
  }
  /**
   * Try to attach all the channels in a room.
   *
   * If the operation succeeds, the room enters the attached state and this promise resolves.
   * If a channel enters the suspended state, then we reject, but we will retry after a short delay as is the case
   * in the core SDK.
   * If a channel enters the failed state, we reject and then begin to wind down the other channels.
   */
  attach() {
    return this._logger.trace("RoomLifecycleManager.attach();"), this._mtx.runExclusive(
      async () => {
        if (this._lifecycle.status !== m.Attached) {
          if (this._lifecycle.status === m.Released)
            throw new f.ErrorInfo("unable to attach room; room is released", v.RoomIsReleased, 500);
          if (this._lifecycle.status === m.Releasing)
            throw new f.ErrorInfo("unable to attach room; room is releasing", v.RoomIsReleasing, 500);
          return this._clearAllTransientDetachTimeouts(), this._startLifecycleOperation(), this._lifecycle.setStatus({ status: m.Attaching }), this._doAttach().then((e) => {
            var t;
            if (e.status === m.Failed)
              throw this._logger.debug("RoomLifecycleManager.attach(); room entered failed, winding down channels", { result: e }), this._mtx.runExclusive(
                () => this._runDownChannelsOnFailedAttach().finally(() => this._operationInProgress = !1),
                2
                /* Internal */
              ), e.error ?? new f.ErrorInfo("unknown error in attach", v.RoomLifecycleError, 500);
            if (e.status === m.Suspended) {
              this._logger.debug("RoomLifecycleManager.attach(); room entered suspended, will retry", {
                error: e.error,
                contributor: (t = e.failedFeature) == null ? void 0 : t.channel.name
              });
              const n = e.failedFeature;
              throw n ? (this._mtx.runExclusive(
                () => this._doRetry(n).catch(),
                2
                /* Internal */
              ), e.error ?? new f.ErrorInfo("unknown error in attach then block", v.RoomLifecycleError, 500)) : new f.ErrorInfo("no failed feature in attach", v.RoomLifecycleError, 500);
            }
          });
        }
      },
      0
      /* AttachOrDetach */
    );
  }
  async _doAttach() {
    this._logger.trace("RoomLifecycleManager._doAttach();");
    const e = {
      status: m.Attached
    };
    for (const t of this._contributors)
      try {
        this._logger.debug("RoomLifecycleManager._doAttach(); attaching", { channel: t.channel.name }), await t.channel.attach(), this._logger.debug("RoomLifecycleManager._doAttach(); attached", { channel: t.channel.name }), this._firstAttachesCompleted.set(t, !0);
      } catch (n) {
        switch (this._logger.error("RoomLifecycleManager._doAttach(); failed to attach", { error: e.error }), e.failedFeature = t, e.error = new f.ErrorInfo(
          "failed to attach feature",
          t.attachmentErrorCode,
          500,
          n
        ), t.channel.state) {
          case "suspended": {
            e.status = m.Suspended;
            break;
          }
          case "failed": {
            e.status = m.Failed;
            break;
          }
          default:
            this._logger.error("Unexpected channel state", { state: t.channel.state }), e.status = m.Failed, e.error = new f.ErrorInfo(
              `unexpected channel state in doAttach ${t.channel.state}`,
              v.RoomLifecycleError,
              500,
              e.error
            );
        }
        return this._lifecycle.setStatus(e), e;
      }
    this._lifecycle.setStatus(e), this._endLifecycleOperation();
    for (const [t, n] of this._pendingDiscontinuityEvents)
      t.discontinuityDetected(n);
    return this._pendingDiscontinuityEvents.clear(), e;
  }
  /**
   * If we've failed to attach, then we're in the failed state and all that is left to do is to detach all the channels.
   *
   * @returns A promise that resolves when all channels are detached. We do not throw.
   */
  _runDownChannelsOnFailedAttach() {
    return this._doChannelWindDown().catch(() => (this._logger.debug("RoomLifecycleManager._runDownChannelsOnFailedAttach(); wind down failed, retrying"), new Promise((e) => {
      setTimeout(() => {
        e(this._runDownChannelsOnFailedAttach());
      }, 250);
    })));
  }
  /**
   * Detach all features except the one exception provided.
   * If the room is in a failed state, then all channels should either reach the failed state or be detached.
   *
   * @param except The contributor to exclude from the detachment.
   * @returns A promise that resolves when all channels are detached.
   */
  _doChannelWindDown(e) {
    return Promise.all(
      this._contributors.map(async (t) => {
        if (!(t.channel === (e == null ? void 0 : e.channel) && this._lifecycle.status !== m.Failed)) {
          if ((this._lifecycle.status === m.Failed || this._lifecycle.status === m.Releasing || this._lifecycle.status === m.Released) && t.channel.state === "failed") {
            this._logger.debug("RoomLifecycleManager._doChannelWindDown(); ignoring failed channel", {
              channel: t.channel.name
            });
            return;
          }
          try {
            this._logger.debug("RoomLifecycleManager._doChannelWindDown(); detaching", {
              channel: t.channel.name
            }), await t.channel.detach(), this._logger.debug("RoomLifecycleManager._doChannelWindDown(); detached", {
              channel: t.channel.name
            });
          } catch (n) {
            if (t.channel.state === "failed" && this._lifecycle.status !== m.Failed && this._lifecycle.status !== m.Releasing && this._lifecycle.status !== m.Released) {
              const s = new f.ErrorInfo(
                "failed to detach feature",
                t.detachmentErrorCode,
                500,
                n
              );
              throw this._lifecycle.setStatus({ status: m.Failed, error: s }), s;
            }
            throw new f.ErrorInfo("detach failure, retry", -1, -1, n);
          }
        }
      })
    );
  }
  /**
   * Detaches the room. If the room is already detached, this is a no-op.
   * If one of the channels fails to detach, the room status will be set to failed.
   * If the room is in the process of detaching, this will wait for the detachment to complete.
   *
   * @returns A promise that resolves when the room is detached.
   */
  detach() {
    return this._logger.trace("RoomLifecycleManager.detach();"), this._mtx.runExclusive(
      async () => {
        if (this._lifecycle.status !== m.Detached) {
          if (this._lifecycle.status === m.Released)
            throw new f.ErrorInfo("unable to detach room; room is released", v.RoomIsReleased, 500);
          if (this._lifecycle.status === m.Releasing)
            throw new f.ErrorInfo("unable to detach room; room is releasing", v.RoomIsReleasing, 500);
          if (this._lifecycle.status === m.Failed)
            throw new f.ErrorInfo("unable to detach room; room has failed", v.RoomInFailedState, 500);
          return this._startLifecycleOperation(), this._clearAllTransientDetachTimeouts(), this._lifecycle.setStatus({ status: m.Detaching }), this._doDetach();
        }
      },
      0
      /* AttachOrDetach */
    );
  }
  /**
   * Perform a detach.
   *
   * If detaching a channel fails, we should retry until every channel is either in the detached state, or in the failed state.
   */
  async _doDetach() {
    this._logger.trace("RoomLifecycleManager._doDetach();");
    let e, t = !1;
    for (; !t; ) {
      try {
        this._logger.debug("RoomLifecycleManager._doDetach(); detaching all channels"), await this._doChannelWindDown();
      } catch (n) {
        if (this._logger.error("RoomLifecycleManager._doDetach(); failed to detach all channels", { error: n }), n instanceof f.ErrorInfo && n.code === -1) {
          this._logger.debug("RoomLifecycleManager._doDetach(); retrying detach", { error: n }), await new Promise((s) => setTimeout(s, 250));
          continue;
        }
        e || (this._logger.debug("RoomLifecycleManager._doDetach(); channel failed on detach", { error: n }), e = n), await new Promise((s) => setTimeout(s, 250)), this._logger.debug("RoomLifecycleManager._doDetach(); retrying detach after failed channel");
        continue;
      }
      t = !0;
    }
    if (this._endLifecycleOperation(), this._lifecycle.status !== m.Failed) {
      this._lifecycle.setStatus({ status: m.Detached });
      return;
    }
    throw e ?? new f.ErrorInfo("unknown error in _doDetach", v.RoomLifecycleError, 500);
  }
  /**
   * Releases the room. If the room is already released, this is a no-op.
   * Any channel that detaches into the failed state is ok. But any channel that fails to detach
   * will cause the room status to be set to failed.
   *
   * @returns Returns a promise that resolves when the room is released. If a channel detaches into a non-terminated
   * state (e.g. attached), the promise will reject.
   */
  release() {
    return this._logger.trace("RoomLifecycleManager.release();"), this._mtx.runExclusive(
      async () => {
        if (this._lifecycle.status !== m.Released) {
          if (this._lifecycle.status === m.Detached || this._lifecycle.status === m.Initialized) {
            this._lifecycle.setStatus({ status: m.Released });
            return;
          }
          return this._releaseInProgress ? new Promise((e, t) => {
            this._lifecycle.onChangeOnce((n) => {
              if (n.current === m.Released) {
                e();
                return;
              }
              this._logger.error("RoomLifecycleManager.release(); expected a non-attached state", n), t(
                new f.ErrorInfo(
                  "failed to release room; existing attempt failed",
                  v.PreviousOperationFailed,
                  500,
                  n.error
                )
              );
            });
          }) : (this._clearAllTransientDetachTimeouts(), this._startLifecycleOperation(), this._releaseInProgress = !0, this._lifecycle.setStatus({ status: m.Releasing }), this._logger.debug("RoomLifecycleManager.release(); releasing room"), this._releaseChannels());
        }
      },
      1
      /* Release */
    );
  }
  /**
   *  Releases the room by detaching all channels. If the release operation fails, we wait
   *  a short period and then try again.
   */
  _releaseChannels() {
    return this._doRelease().catch((e) => (this._logger.error("RoomLifecycleManager._releaseChannels(); failed to release room, retrying", { error: e }), new Promise((t) => {
      setTimeout(() => {
        t(this._releaseChannels());
      }, 250);
    })));
  }
  /**
   * Performs the release operation. This will detach all channels in the room that aren't
   * already detached or in the failed state.
   */
  _doRelease() {
    return Promise.all(
      this._contributors.map(async (e) => {
        if (e.channel.state === "failed") {
          this._logger.debug("RoomLifecycleManager.release(); ignoring failed channel", {
            channel: e.channel.name
          });
          return;
        }
        if (e.channel.state === "detached") {
          this._logger.debug("RoomLifecycleManager.release(); ignoring detached channel", {
            channel: e.channel.name
          });
          return;
        }
        try {
          this._logger.debug("RoomLifecycleManager.release(); detaching", {
            channel: e.channel.name
          }), await e.channel.detach(), this._logger.debug("RoomLifecycleManager.release(); detached", {
            channel: e.channel.name
          });
        } catch (t) {
          throw this._logger.error("RoomLifecycleManager.release(); failed to detach", {
            error: t,
            channel: e.channel.name,
            state: e.channel.state
          }), t;
        }
      })
    ).then(() => {
      this._releaseInProgress = !1, this._endLifecycleOperation(), this._lifecycle.setStatus({ status: m.Released });
    });
  }
  /**
   * Starts the room lifecycle operation.
   */
  _startLifecycleOperation() {
    this._logger.debug("RoomLifecycleManager._startLifecycleOperation();"), this._operationInProgress = !0;
  }
  /**
   * Ends the room lifecycle operation.
   */
  _endLifecycleOperation() {
    this._logger.debug("RoomLifecycleManager._endLifecycleOperation();"), this._operationInProgress = !1;
  }
}
const hi = {
  /**
   * The default presence options for a chat room.
   */
  presence: {
    /**
     * The client should be able to enter presence.
     */
    enter: !0,
    /**
     * The client should be able to subscribe to presence.
     */
    subscribe: !0
  },
  /**
   * The default typing options for a chat room.
   */
  typing: {
    /**
     * The default timeout for typing events in milliseconds.
     */
    timeoutMs: 5e3
  },
  /**
   * The default reactions options for a chat room.
   */
  reactions: {},
  /**
   * The default occupancy options for a chat room.
   */
  occupancy: {}
}, Br = (r) => new f.ErrorInfo(`invalid room configuration: ${r}`, 40001, 400), zr = (r) => {
  if (r.typing && r.typing.timeoutMs <= 0)
    throw Br("typing timeout must be greater than 0");
}, Wr = (r, e) => ({
  ...r,
  isReactClient: e
});
class Gr {
  constructor(e, t, n, s, c, o) {
    this.type = e, this.clientId = t, this.createdAt = n, this.isSelf = s, this.metadata = c, this.headers = o, Object.freeze(this);
  }
}
function Vr(r, e) {
  var n;
  const t = r;
  if (!t.data)
    throw new f.ErrorInfo("received incoming message without data", 5e4, 500);
  if (!t.data.type || typeof t.data.type != "string")
    throw new f.ErrorInfo("invalid reaction message with no type", 5e4, 500);
  if (!t.clientId)
    throw new f.ErrorInfo("received incoming message without clientId", 5e4, 500);
  if (!t.timestamp)
    throw new f.ErrorInfo("received incoming message without timestamp", 5e4, 500);
  return new Gr(
    t.data.type,
    t.clientId,
    new Date(t.timestamp),
    e ? e === t.clientId : !1,
    t.data.metadata ?? {},
    ((n = t.extras) == null ? void 0 : n.headers) ?? {}
  );
}
class Hr extends K {
  /**
   * Constructs a new `DefaultRoomReactions` instance.
   * @param roomId The unique identifier of the room.
   * @param channelManager The ChannelManager instance.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s) {
    super(), this._discontinuityEmitter = me(), this._forwarder = (c) => {
      const o = this._parseNewReaction(c, this._clientId);
      o && this.emit(Ce.Reaction, o);
    }, this._channel = this._makeChannel(e, t), this._clientId = n, this._logger = s;
  }
  /**
   * Creates the realtime channel for room reactions.
   */
  _makeChannel(e, t) {
    const n = t.get(`${e}::$chat::$reactions`);
    return n.subscribe([Ce.Reaction], this._forwarder.bind(this)), n;
  }
  /**
   * @inheritDoc Reactions
   */
  send(e) {
    this._logger.trace("RoomReactions.send();", e);
    const { type: t, metadata: n, headers: s } = e;
    if (!t)
      return Promise.reject(new f.ErrorInfo("unable to send reaction; type not set and it is required", 40001, 400));
    const c = {
      type: t,
      metadata: n ?? {}
    }, o = {
      name: Ce.Reaction,
      data: c,
      extras: {
        headers: s ?? {}
      }
    };
    return this._channel.publish(o);
  }
  /**
   * @inheritDoc Reactions
   */
  subscribe(e) {
    return this._logger.trace("RoomReactions.subscribe();"), this.on(e), {
      unsubscribe: () => {
        this._logger.trace("RoomReactions.unsubscribe();"), this.off(e);
      }
    };
  }
  /**
   * @inheritDoc Reactions
   */
  unsubscribeAll() {
    this._logger.trace("RoomReactions.unsubscribeAll();"), this.off();
  }
  get channel() {
    return this._channel;
  }
  _parseNewReaction(e, t) {
    try {
      return Vr(e, t);
    } catch (n) {
      this._logger.error("failed to parse incoming reaction;", { inbound: e, error: n });
    }
  }
  discontinuityDetected(e) {
    this._logger.warn("RoomReactions.discontinuityDetected();", { reason: e }), this._discontinuityEmitter.emit("discontinuity", e);
  }
  onDiscontinuity(e) {
    return this._logger.trace("RoomReactions.onDiscontinuity();"), this._discontinuityEmitter.on(e), {
      off: () => {
        this._discontinuityEmitter.off(e);
      }
    };
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get attachmentErrorCode() {
    return v.ReactionsAttachmentFailed;
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get detachmentErrorCode() {
    return v.ReactionsDetachmentFailed;
  }
}
const Qr = 1500, Kr = 3e4, Xr = 5;
class Yr extends K {
  /**
   * Constructs a new `DefaultTyping` instance.
   * @param roomId The unique identifier of the room.
   * @param options The options for typing in the room.
   * @param channelManager The channel manager for the room.
   * @param clientId The client ID of the user.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s, c) {
    super(), this._discontinuityEmitter = me(), this._receivedEventNumber = 0, this._triggeredEventNumber = 0, this._currentlyTyping = /* @__PURE__ */ new Set(), this._numRetries = 0, this._internalSubscribeToEvents = (o) => {
      if (!o.clientId) {
        this._logger.error("unable to handle typing event; no clientId", { member: o });
        return;
      }
      this._receivedEventNumber += 1, this._retryTimeout && (clearTimeout(this._retryTimeout), this._retryTimeout = void 0, this._numRetries = 0), this._getAndEmit(this._receivedEventNumber);
    }, this._clientId = s, this._channel = this._makeChannel(e, n), this._typingTimeoutMs = t.timeoutMs, this._logger = c;
  }
  /**
   * Creates the realtime channel for typing indicators.
   */
  _makeChannel(e, t) {
    const n = t.get(`${e}::$chat::$typingIndicators`);
    return n.presence.subscribe(this._internalSubscribeToEvents.bind(this)), n;
  }
  /**
   * @inheritDoc
   */
  get() {
    return this._logger.trace("DefaultTyping.get();"), this._channel.presence.get().then((e) => new Set(e.map((t) => t.clientId)));
  }
  /**
   * @inheritDoc
   */
  get channel() {
    return this._channel;
  }
  /**
   * Start the typing timeout timer. This will emit a typingStopped event if the timer expires.
   */
  _startTypingTimer() {
    this._logger.trace("DefaultTyping.startTypingTimer();"), this._timerId = setTimeout(() => {
      this._logger.debug("DefaultTyping.startTypingTimer(); timeout expired"), this.stop();
    }, this._typingTimeoutMs);
  }
  /**
   * @inheritDoc
   */
  async start() {
    if (this._logger.trace("DefaultTyping.start();"), this._timerId) {
      this._logger.debug("DefaultTyping.start(); already typing, resetting timer"), clearTimeout(this._timerId), this._startTypingTimer();
      return;
    }
    return this._startTypingTimer(), this._channel.presence.enterClient(this._clientId);
  }
  /**
   * @inheritDoc
   */
  async stop() {
    return this._logger.trace("DefaultTyping.stop();"), this._timerId && (clearTimeout(this._timerId), this._timerId = void 0), this._channel.presence.leaveClient(this._clientId);
  }
  /**
   * @inheritDoc
   */
  subscribe(e) {
    return this._logger.trace("DefaultTyping.subscribe();"), this.on(e), {
      unsubscribe: () => {
        this._logger.trace("DefaultTyping.unsubscribe();"), this.off(e);
      }
    };
  }
  /**
   * @inheritDoc
   */
  unsubscribeAll() {
    this._logger.trace("DefaultTyping.unsubscribeAll();"), this.off();
  }
  _getAndEmit(e) {
    this.get().then((t) => {
      this._retryTimeout && (clearTimeout(this._retryTimeout), this._retryTimeout = void 0, this._numRetries = 0), !(this._triggeredEventNumber >= e) && (this._triggeredEventNumber = e, !ue(this._currentlyTyping, t) && (this._currentlyTyping = t, this.emit(Pt.Changed, {
        currentlyTyping: new Set(t)
      })));
    }).catch((t) => {
      const n = this._numRetries < Xr;
      if (this._logger.error("Error fetching currently typing clientIds set.", {
        error: t,
        willReattempt: n
      }), !n || this._retryTimeout)
        return;
      const s = Math.min(
        Kr,
        Qr * Math.pow(2, this._numRetries)
      );
      this._numRetries += 1, this._retryTimeout = setTimeout(() => {
        this._retryTimeout = void 0, this._receivedEventNumber++, this._getAndEmit(this._receivedEventNumber);
      }, s);
    });
  }
  onDiscontinuity(e) {
    return this._logger.trace("DefaultTyping.onDiscontinuity();"), this._discontinuityEmitter.on(e), {
      off: () => {
        this._discontinuityEmitter.off(e);
      }
    };
  }
  discontinuityDetected(e) {
    this._logger.warn("DefaultTyping.discontinuityDetected();", { reason: e }), this._discontinuityEmitter.emit("discontinuity", e);
  }
  get timeoutMs() {
    return this._typingTimeoutMs;
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get attachmentErrorCode() {
    return v.TypingAttachmentFailed;
  }
  /**
   * @inheritdoc ContributesToRoomLifecycle
   */
  get detachmentErrorCode() {
    return v.TypingDetachmentFailed;
  }
}
class Jr {
  /**
   * Constructs a new Room instance.
   *
   * @param roomId The unique identifier of the room.
   * @param nonce A random identifier for the room instance, useful in debugging and logging.
   * @param options The options for the room.
   * @param realtime An instance of the Ably Realtime client.
   * @param chatApi An instance of the ChatApi.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n, s, c, o) {
    zr(n), this._nonce = t, o.debug("Room();", { roomId: e, options: n, nonce: this._nonce }), this._roomId = e, this._options = n, this._chatApi = c, this._logger = o, this._lifecycle = new Ur(e, o);
    const d = this._channelManager = this._getChannelManager(n, s, o);
    this._messages = new vr(e, d, this._chatApi, s.auth.clientId, o);
    const y = [this._messages];
    n.presence && (this._logger.debug("enabling presence on room", { roomId: e }), this._presence = new _e(e, d, s.auth.clientId, o), y.push(this._presence)), n.typing && (this._logger.debug("enabling typing on room", { roomId: e }), this._typing = new Yr(e, n.typing, d, s.auth.clientId, o), y.push(this._typing)), n.reactions && (this._logger.debug("enabling reactions on room", { roomId: e }), this._reactions = new Hr(e, d, s.auth.clientId, o), y.push(this._reactions)), n.occupancy && (this._logger.debug("enabling occupancy on room", { roomId: e }), this._occupancy = new fe(e, d, this._chatApi, o), y.push(this._occupancy)), this._lifecycleManager = new $r(this._lifecycle, [...y].reverse(), this._logger, 5e3);
    let l = !1;
    this._finalizer = async () => {
      if (l) {
        this._logger.debug("Room.finalizer(); already finalized");
        return;
      }
      await this._lifecycleManager.release();
      for (const h of y)
        d.release(h.channel.name);
      l = !0;
    };
  }
  /**
   * Gets the channel manager for the room, which handles merging channel options together and creating channels.
   *
   * @param options The room options.
   * @param realtime  An instance of the Ably Realtime client.
   * @param logger An instance of the Logger.
   */
  _getChannelManager(e, t, n) {
    const s = new Lr(t, n, e.isReactClient);
    return e.occupancy && s.mergeOptions(fe.channelName(this._roomId), fe.channelOptionMerger()), e.presence && s.mergeOptions(_e.channelName(this._roomId), _e.channelOptionMerger(e)), s;
  }
  /**
   * @inheritdoc Room
   */
  get roomId() {
    return this._roomId;
  }
  /**
   * @inheritDoc Room
   */
  options() {
    return Mr(this._options);
  }
  /**
   * @inheritdoc Room
   */
  get messages() {
    return this._messages;
  }
  /**
   * @inheritdoc Room
   */
  get presence() {
    if (!this._presence)
      throw this._logger.error("Presence is not enabled for this room"), new f.ErrorInfo("Presence is not enabled for this room", 4e4, 400);
    return this._presence;
  }
  /**
   * @inheritdoc Room
   */
  get reactions() {
    if (!this._reactions)
      throw this._logger.error("Reactions are not enabled for this room"), new f.ErrorInfo("Reactions are not enabled for this room", 4e4, 400);
    return this._reactions;
  }
  /**
   * @inheritdoc Room
   */
  get typing() {
    if (!this._typing)
      throw this._logger.error("Typing is not enabled for this room"), new f.ErrorInfo("Typing is not enabled for this room", 4e4, 400);
    return this._typing;
  }
  /**
   * @inheritdoc Room
   */
  get occupancy() {
    if (!this._occupancy)
      throw this._logger.error("Occupancy is not enabled for this room"), new f.ErrorInfo("Occupancy is not enabled for this room", 4e4, 400);
    return this._occupancy;
  }
  /**
   * @inheritdoc Room
   */
  get status() {
    return this._lifecycle.status;
  }
  /**
   * @inheritdoc Room
   */
  get error() {
    return this._lifecycle.error;
  }
  /**
   * @inheritdoc Room
   */
  onStatusChange(e) {
    return this._lifecycle.onChange(e);
  }
  /**
   * @inheritdoc Room
   */
  offAllStatusChange() {
    this._lifecycle.offAll();
  }
  /**
   * @inheritdoc Room
   */
  async attach() {
    return this._logger.trace("Room.attach();", { nonce: this._nonce, roomId: this._roomId }), this._lifecycleManager.attach();
  }
  /**
   * @inheritdoc Room
   */
  async detach() {
    return this._logger.trace("Room.detach();", { nonce: this._nonce, roomId: this._roomId }), this._lifecycleManager.detach();
  }
  /**
   * Releases resources associated with the room.
   * We guarantee that this does not throw an error.
   */
  release() {
    return this._logger.trace("Room.release();", { nonce: this._nonce, roomId: this._roomId }), this._finalizer();
  }
  /**
   * A random identifier for the room instance, useful in debugging and logging.
   *
   * @returns The nonce.
   */
  get nonce() {
    return this._nonce;
  }
  /**
   * @internal
   *
   * Returns the rooms lifecycle.
   */
  get lifecycle() {
    return this._lifecycle;
  }
  get channelManager() {
    return this._channelManager;
  }
}
class Zr {
  /**
   * Constructs a new Rooms instance.
   *
   * @param realtime An instance of the Ably Realtime client.
   * @param clientOptions The client options from the chat instance.
   * @param logger An instance of the Logger.
   */
  constructor(e, t, n) {
    this._rooms = /* @__PURE__ */ new Map(), this._releasing = /* @__PURE__ */ new Map(), this._isReact = !1, this._realtime = e, this._chatApi = new Ir(e, n), this._clientOptions = t, this._logger = n;
  }
  /**
   * @inheritDoc
   */
  get(e, t) {
    this._logger.trace("Rooms.get();", { roomId: e });
    const n = this._rooms.get(e);
    if (n)
      return ue(n.options, t) ? (this._logger.debug("Rooms.get(); returning existing room", { roomId: e, nonce: n.nonce }), n.promise) : Promise.reject(new f.ErrorInfo("room already exists with different options", 4e4, 400));
    const s = this._releasing.get(e), c = Cr();
    if (!s) {
      const y = this._makeRoom(e, c, t), l = {
        promise: Promise.resolve(y),
        nonce: c,
        options: t
      };
      return this._rooms.set(e, l), this._logger.debug("Rooms.get(); returning new room", { roomId: e, nonce: y.nonce }), l.promise;
    }
    const o = new AbortController(), d = new Promise((y, l) => {
      const h = () => {
        this._logger.debug("Rooms.get(); aborted before init", { roomId: e }), l(
          new f.ErrorInfo(
            "room released before get operation could complete",
            v.RoomReleasedBeforeOperationCompleted,
            400
          )
        );
      };
      o.signal.addEventListener("abort", h), s.then(() => {
        if (o.signal.aborted) {
          this._logger.debug("Rooms.get(); aborted before releasing promise resolved", { roomId: e });
          return;
        }
        this._logger.debug("Rooms.get(); releasing finished", { roomId: e });
        const _ = this._makeRoom(e, c, t);
        o.signal.removeEventListener("abort", h), y(_);
      }).catch((_) => {
        l(_);
      });
    });
    return this._rooms.set(e, {
      promise: d,
      options: t,
      nonce: c,
      abort: o
    }), this._logger.debug("Rooms.get(); creating new promise dependent on previous release", { roomId: e }), d;
  }
  /**
   * @inheritDoc
   */
  get clientOptions() {
    return this._clientOptions;
  }
  /**
   * @inheritDoc
   */
  release(e) {
    this._logger.trace("Rooms.release();", { roomId: e });
    const t = this._rooms.get(e), n = this._releasing.get(e);
    if (!t)
      return n ? (this._logger.debug("Rooms.release(); waiting for previous release call", {
        roomId: e
      }), n) : (this._logger.debug("Rooms.release(); room does not exist", { roomId: e }), Promise.resolve());
    if (n)
      return t.abort && (this._logger.debug("Rooms.release(); aborting get call", { roomId: e, existingNonce: t.nonce }), t.abort.abort(), this._rooms.delete(e)), n;
    this._rooms.delete(e);
    const s = t.promise.then((c) => (this._logger.debug("Rooms.release(); releasing room", { roomId: e, nonce: t.nonce }), c.release().then(() => {
      this._logger.debug("Rooms.release(); room released", { roomId: e, nonce: t.nonce }), this._releasing.delete(e);
    })));
    return this._logger.debug("Rooms.release(); creating new release promise", { roomId: e, nonce: t.nonce }), this._releasing.set(e, s), s;
  }
  /**
   * makes a new room object
   *
   * @param roomId The ID of the room.
   * @param nonce A random, internal identifier useful for debugging and logging.
   * @param options The options for the room.
   *
   * @returns DefaultRoom A new room object.
   */
  _makeRoom(e, t, n) {
    return new Jr(
      e,
      t,
      Wr(n, this._isReact),
      this._realtime,
      this._chatApi,
      this._logger
    );
  }
  /**
   * Sets react JS mode.
   */
  useReact() {
    this._logger.trace("Rooms.useReact();"), this._isReact = !0;
  }
}
class li {
  /**
   * Constructor for Chat
   * @param realtime - The Ably Realtime client.
   * @param clientOptions - The client options.
   */
  constructor(e, t) {
    this._realtime = e, this._clientOptions = _r(t), this._logger = lr(this._clientOptions), this._connection = new pr(e, this._logger), this._rooms = new Zr(e, this._clientOptions, this._logger), this._addAgent("chat-js"), this._logger.trace(`ably chat client version ${Se}; initialized`);
  }
  /**
   * Returns the rooms object, which provides access to chat rooms.
   *
   * @returns The rooms object.
   */
  get rooms() {
    return this._rooms;
  }
  /**
   * Returns the underlying connection to Ably, which can be used to monitor the client's
   * connection to Ably servers.
   *
   * @returns The connection object.
   */
  get connection() {
    return this._connection;
  }
  /**
   * Returns the clientId of the current client.
   *
   * @returns The clientId.
   */
  get clientId() {
    return this._realtime.auth.clientId;
  }
  /**
   * Returns the underlying Ably Realtime client.
   * @returns The Ably Realtime client.
   */
  get realtime() {
    return this._realtime;
  }
  /**
   * Returns the resolved client options for the client, including any defaults that have been set.
   * @returns The client options.
   */
  get clientOptions() {
    return this._clientOptions;
  }
  /**
   * Returns the logger instance for the client.
   * @internal
   * @returns The logger instance.
   */
  get logger() {
    return this._logger;
  }
  /**
   * Adds additional agent information to the client.
   * Used internally to add React-specific agent information.
   * @internal
   */
  addReactAgent() {
    this._addAgent("chat-react"), this._rooms.useReact();
  }
  /**
   * Sets the agent string for the client.
   * @param agent - The agent to add.
   * @internal
   */
  _addAgent(e) {
    const t = this._realtime;
    t.options.agents = { ...t.options.agents ?? t.options.agents, [e]: Se };
  }
}
const xt = ar(void 0), It = Symbol.for("__ABLY_CHAT_CLIENT_CONTEXT__"), Ct = typeof globalThis > "u" ? {} : globalThis;
function ei() {
  let r = Ct[It];
  return r || (r = Ct[It] = Tt.createContext({})), r;
}
const ke = ei(), Ft = "default", di = ({ children: r, client: e }) => {
  const t = bt.useContext(ke), n = bt.useMemo(() => (e.addReactAgent(), { ...t, [Ft]: { client: e } }), [e, t]);
  return /* @__PURE__ */ Mt(ke.Provider, { value: n, children: r });
}, $e = () => {
  const r = Tt.useContext(ke)[Ft];
  if (!r)
    throw new f.ErrorInfo("useChatClient hook must be used within a chat client provider", 4e4, 400);
  return r.client;
}, q = (r) => {
  const e = $(r);
  w(() => {
    e.current = r;
  });
  const t = N((...n) => {
    e.current && e.current(...n);
  }, []);
  return r ? t : void 0;
}, k = () => {
  const r = $e();
  return cr(() => r.logger, [r]);
}, re = (r) => {
  const e = $e(), t = k();
  t.trace("useChatConnection();", r);
  const [n, s] = P(e.connection.status), [c, o] = P(e.connection.error), [d, y] = P(e.connection);
  w(() => {
    y(e.connection), o(e.connection.error), s(e.connection.status);
  }, [e]);
  const l = q(r == null ? void 0 : r.onStatusChange);
  return w(() => {
    t.debug("useChatConnection(); applying internal listener");
    const { off: h } = e.connection.onStatusChange((_) => {
      s(_.current), o(_.error);
    });
    return () => {
      t.debug("useChatConnection(); cleaning up listener"), h();
    };
  }, [e.connection, t]), w(() => {
    if (!l) return;
    t.debug("useChatConnection(); applying client listener");
    const { off: h } = e.connection.onStatusChange(l);
    return () => {
      t.debug("useChatConnection(); cleaning up client listener"), h();
    };
  }, [e.connection, t, l]), {
    currentStatus: n,
    error: c,
    connection: d
  };
};
class ti {
  /**
   * Creates a new DefaultRoomPromise and starts the resolution of the promise.
   *
   * @param room  The promise that resolves to a Room instance.
   * @param onResolve  The callback that is called when the promise resolves to a Room instance.
   * @param logger  The logger to use for logging.
   * @param roomId The ID of the room, used for logging.
   */
  constructor(e, t, n, s) {
    this._unmounted = !1, this._roomId = s, this._onResolve = t, this._logger = n, this.mount(e).catch(() => {
      this._logger.trace("DefaultRoomPromise(); mount error", { roomId: this._roomId });
    });
  }
  /**
   * Wait for the room promise to resolve, then execute the onResolve callback, storing its response as an unmount function.
   * If the component is unmounted before the promise resolves, then this will do nothing.
   *
   * @param promise The promise that resolves to a Room instance.
   * @returns A promise that we simply resolve when it's done.
   */
  async mount(e) {
    this._logger.debug("DefaultRoomPromise(); mount", { roomId: this._roomId });
    try {
      const t = await e;
      if (this._unmounted)
        return;
      this._logger.debug("DefaultRoomPromise(); mount resolved", { roomId: this._roomId }), this._onUnmount = this._onResolve(t);
    } catch (t) {
      this._logger.error("DefaultRoomPromise(); mount error", { roomId: this._roomId, error: t });
    }
  }
  /**
   * Returns a function to be called when the component is unmounted. If the room promise has resolved at the time
   * of calling, then the unmount function returned by the onResolve callback will be called.
   *
   * Multiple calls are no-op.
   *
   * Example usage:
   *
   * ```ts
   *  useEffect(() => {
   *    const roomPromise = wrapRoomPromise(...);
   *    return roomPromise.unmount();
   *  }, []);
   * ```
   *
   * @returns A function that should be called when the component is unmounted.
   */
  unmount() {
    return this._unmounted ? () => {
    } : () => {
      var e;
      this._logger.debug("DefaultRoomPromise(); unmount", { roomId: this._roomId }), this._unmounted = !0, (e = this._onUnmount) == null || e.call(this);
    };
  }
}
function M(r, e, t, n) {
  return new ti(r, e, t, n);
}
const W = (r) => {
  const e = ur(xt);
  if (!e)
    throw new f.ErrorInfo(`${r} hook must be used within a <ChatRoomProvider>`, 4e4, 400);
  return e;
}, ni = (r) => {
  const e = $(r);
  return w(() => {
    e.current = r;
  }), N((...t) => e.current(...t), []);
}, ri = () => {
  const [r, e] = P(), t = W("useEventualRoom"), n = k();
  return n.trace("useEventualRoom();", { roomId: t.roomId }), w(() => {
    n.debug("useEventualRoom(); running useEffect", { roomId: t.roomId });
    let s = !1;
    return t.room.then((c) => {
      if (s) {
        n.debug("useEventualRoom(); already unmounted", { roomId: t.roomId });
        return;
      }
      n.debug("useEventualRoom(); resolved", { roomId: t.roomId }), e(c);
    }).catch((c) => {
      n.error("Failed to get room", { roomId: t.roomId, error: c });
    }), () => {
      n.debug("useEventualRoom(); cleanup", { roomId: t.roomId }), s = !0;
    };
  }, [t, n]), r;
}, he = (r) => {
  const [e, t] = P(), n = W("useEventualRoomProperty"), s = k();
  s.trace("useEventualRoomProperty();", { roomId: n.roomId });
  const c = ni(r);
  return w(() => {
    let o = !1;
    return s.debug("useEventualRoomProperty(); running useEffect", { roomId: n.roomId }), n.room.then((d) => {
      if (o) {
        s.debug("useEventualRoomProperty(); already unmounted", { roomId: n.roomId });
        return;
      }
      s.debug("useEventualRoomProperty(); resolved", { roomId: n.roomId }), t(c(d));
    }).catch((d) => {
      s.error("Failed to get room", { roomId: n.roomId, error: d });
    }), () => {
      s.debug("useEventualRoomProperty(); cleanup", { roomId: n.roomId }), o = !0;
    };
  }, [n, s, c]), e;
}, ie = (r) => {
  const e = W("useRoomStatus"), [t, n] = P(m.Initializing), [s, c] = P(), o = k(), d = q(r == null ? void 0 : r.onRoomStatusChange);
  return w(() => M(
    e.room,
    (l) => {
      o.debug("useRoomStatus(); subscribing internal listener"), n(l.status), c(l.error);
      const { off: h } = l.onStatusChange((_) => {
        o.debug("useRoomStatus(); status change", _), n(_.current), c(_.error);
      });
      return () => {
        o.debug("useRoomStatus(); unsubscribing internal listener"), h();
      };
    },
    o,
    e.roomId
  ).unmount(), [e, o]), w(() => M(
    e.room,
    (l) => {
      let h;
      return d && (o.debug("useRoomStatus(); subscribing to status changes"), h = l.onStatusChange(d).off), o.debug("useRoomStatus(); setting initial status", { status: l.status }), d && (o.debug("useRoomStatus(); sending initial status event"), d({
        current: l.status,
        previous: m.Initializing,
        error: l.error
      })), () => {
        o.debug("useRoomStatus(); unmounting"), h && (o.debug("useRoomStatus(); unsubscribing from status changes"), h());
      };
    },
    o,
    e.roomId
  ).unmount(), [e, o, d]), {
    status: t,
    error: s
  };
}, gi = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("useMessages"), { status: s, error: c } = ie(r), o = k();
  o.trace("useMessages();", { params: r, roomId: n.roomId });
  const d = q(r == null ? void 0 : r.listener), y = q(r == null ? void 0 : r.onDiscontinuity), l = N(
    (p) => n.room.then((b) => b.messages.send(p)),
    [n]
  ), h = N(
    (p, b) => n.room.then((R) => R.messages.delete(p, b)),
    [n]
  ), _ = N(
    (p) => n.room.then((b) => b.messages.get(p)),
    [n]
  ), C = N(
    (p, b) => n.room.then((R) => R.messages.update(p, b)),
    [n]
  ), [E, S] = P();
  return w(() => {
    if (d)
      return M(
        n.room,
        (p) => {
          let b = !1;
          o.debug("useMessages(); applying listener", { roomId: n.roomId });
          const R = p.messages.subscribe(d);
          return S(() => {
            if (o.debug("useMessages(); setting getPreviousMessages state", {
              roomId: n.roomId,
              status: p.status,
              unmounted: b
            }), !b)
              return (T) => (o.debug("useMessages(); getPreviousMessages called", { roomId: n.roomId }), b ? Promise.reject(new f.ErrorInfo("component unmounted", 4e4, 400)) : R.getPreviousMessages(T));
          }), () => {
            o.debug("useMessages(); removing listener and getPreviousMessages state", { roomId: n.roomId }), b = !0, R.unsubscribe(), S(void 0);
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, o, d]), w(() => {
    if (y)
      return M(
        n.room,
        (p) => {
          o.debug("useMessages(); applying onDiscontinuity listener", { roomId: n.roomId });
          const { off: b } = p.messages.onDiscontinuity(y);
          return () => {
            o.debug("useMessages(); removing onDiscontinuity listener", { roomId: n.roomId }), b();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, o, y]), {
    messages: he((p) => p.messages),
    send: l,
    update: C,
    get: _,
    deleteMessage: h,
    getPreviousMessages: E,
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c
  };
}, fi = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("useOccupancy"), { status: s, error: c } = ie(r), o = k();
  o.trace("useOccupancy();", { params: r, roomId: n.roomId });
  const [d, y] = P({
    connections: 0,
    presenceMembers: 0
  }), l = q(r == null ? void 0 : r.listener), h = q(r == null ? void 0 : r.onDiscontinuity);
  return w(() => {
    if (h)
      return M(
        n.room,
        (_) => {
          o.debug("useOccupancy(); applying onDiscontinuity listener", { roomId: n.roomId });
          const { off: C } = _.occupancy.onDiscontinuity(h);
          return () => {
            o.debug("useOccupancy(); removing onDiscontinuity listener", { roomId: n.roomId }), C();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, h, o]), w(() => M(
    n.room,
    (_) => {
      o.debug("useOccupancy(); applying internal listener", { roomId: n.roomId });
      const { unsubscribe: C } = _.occupancy.subscribe((E) => {
        y({
          connections: E.connections,
          presenceMembers: E.presenceMembers
        });
      });
      return () => {
        o.debug("useOccupancy(); cleaning up internal listener", { roomId: n.roomId }), C();
      };
    },
    o,
    n.roomId
  ).unmount(), [n, o]), w(() => {
    if (l)
      return M(
        n.room,
        (_) => {
          o.debug("useOccupancy(); applying listener", { roomId: n.roomId });
          const { unsubscribe: C } = _.occupancy.subscribe(l);
          return () => {
            o.debug("useOccupancy(); cleaning up listener", { roomId: n.roomId }), C();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [l, n, o]), {
    occupancy: he((_) => _.occupancy),
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c,
    connections: d.connections,
    presenceMembers: d.presenceMembers
  };
}, St = /* @__PURE__ */ new Set([qe.Suspended, qe.Failed]), _i = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("usePresence"), { status: s, error: c } = ie(r), o = k();
  o.trace("usePresence();", { params: r, roomId: n.roomId });
  const [d, y] = P(!1), [l, h] = P(), _ = $({ roomStatus: s, connectionStatus: e }), C = q(r == null ? void 0 : r.onDiscontinuity), E = $(r);
  w(() => {
    E.current = r;
  }, [r]), w(() => {
    _.current = { roomStatus: s, connectionStatus: e };
  }, [s, e]), w(() => (o.debug("usePresence(); entering room", { roomId: n.roomId }), M(
    n.room,
    (p) => {
      var R;
      return p.status === m.Attached && !St.has(e) ? (p.presence.enter((R = E.current) == null ? void 0 : R.enterWithData).then(() => {
        o.debug("usePresence(); entered room", { roomId: n.roomId }), y(!0), h(void 0);
      }).catch((T) => {
        o.error("usePresence(); error entering room", { error: T, roomId: n.roomId }), h(T);
      }), () => {
        var L;
        const T = p.status === m.Attached && !St.has(_.current.connectionStatus);
        o.debug("usePresence(); unmounting", {
          roomId: n.roomId,
          canLeavePresence: T,
          roomStatus: s,
          connectionStatus: e
        }), T && p.presence.leave((L = E.current) == null ? void 0 : L.leaveWithData).then(() => {
          o.debug("usePresence(); left room", { roomId: n.roomId }), y(!1), h(void 0);
        }).catch((B) => {
          o.error("usePresence(); error leaving room", { error: B, roomId: n.roomId }), h(B);
        });
      }) : (o.debug("usePresence(); skipping enter room", { roomStatus: s, connectionStatus: e, roomId: n.roomId }), () => {
      });
    },
    o,
    n.roomId
  ).unmount()), [n, e, s, o]), w(() => {
    if (C)
      return M(
        n.room,
        (p) => {
          const { off: b } = p.presence.onDiscontinuity(C);
          return () => {
            o.debug("usePresence(); removing onDiscontinuity listener", { roomId: n.roomId }), b();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, C, o]);
  const S = N(
    (p) => n.room.then((b) => b.presence.update(p).then(() => {
      y(!0), h(void 0);
    })),
    [n]
  );
  return {
    presence: he((p) => p.presence),
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c,
    update: S,
    isPresent: d,
    error: l
  };
}, ii = 1500, si = 3e4, oi = 5, mi = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("usePresenceListener"), { status: s, error: c } = ie(r), o = k();
  o.trace("usePresenceListener();", { roomId: n.roomId });
  const d = $(0), y = $(0), l = $(void 0), h = $(0), _ = $([]), [C, E] = P([]), S = $(void 0), [p, b] = P(), R = q(r == null ? void 0 : r.listener), T = q(r == null ? void 0 : r.onDiscontinuity), L = N(
    (O) => {
      o.debug("usePresenceListener(); setting error state", { error: O, roomId: n.roomId }), S.current = O, b(O);
    },
    [o, n]
  ), B = N(() => {
    o.debug("usePresenceListener(); clearing error state", { roomId: n.roomId }), S.current = void 0, b(void 0);
  }, [o, n]);
  return w(() => {
    const O = () => {
      d.current += 1, l.current && (clearTimeout(l.current), l.current = void 0, h.current = 0), U(d.current);
    }, U = (z) => {
      M(
        n.room,
        (G) => (G.presence.get({ waitForSync: !0 }).then((D) => {
          o.debug("usePresenceListener(); fetched presence data", { presenceMembers: D, roomId: n.roomId }), l.current && (clearTimeout(l.current), l.current = void 0, h.current = 0), !(y.current >= z) && (y.current = z, _.current = D, E(D), S.current && B());
        }).catch(() => {
          if (!(h.current < oi)) {
            o.error("usePresenceListener(); failed to fetch presence data after max retries", {
              roomId: n.roomId
            }), L(new f.ErrorInfo("failed to fetch presence data after max retries", 5e4, 500));
            return;
          }
          if (l.current) {
            o.debug("usePresenceListener(); waiting for retry but new event received", {
              roomId: n.roomId
            });
            return;
          }
          const Z = Math.min(
            si,
            ii * Math.pow(2, h.current)
          );
          h.current += 1, o.debug("usePresenceListener(); retrying to fetch presence data", {
            numRetries: h.current,
            roomId: n.roomId
          }), l.current = setTimeout(() => {
            l.current = void 0, d.current += 1, U(d.current);
          }, Z);
        }), () => {
        }),
        o,
        n.roomId
      );
    };
    return M(
      n.room,
      (z) => {
        let G;
        return z.status === m.Attached ? z.presence.get({ waitForSync: !0 }).then((D) => {
          o.debug("usePresenceListener(); fetched initial presence data", {
            presenceMembers: D,
            roomId: n.roomId
          }), _.current = D, E(D), B();
        }).catch((D) => {
          const Z = D;
          Ot(Z, v.RoomIsReleased) || (o.error("usePresenceListener(); error fetching initial presence data", {
            error: D,
            roomId: n.roomId
          }), L(Z));
        }).finally(() => {
          o.debug("usePresenceListener(); subscribing internal listener to presence events", {
            roomId: n.roomId
          }), G = z.presence.subscribe(() => {
            O();
          }).unsubscribe;
        }) : (o.debug("usePresenceListener(); not yet attached, subscribing internal listener to presence events", {
          roomId: n.roomId
        }), G = z.presence.subscribe(() => {
          O();
        }).unsubscribe), () => {
          G && (o.debug("usePresenceListener(); cleaning up internal listener", { roomId: n.roomId }), G());
        };
      },
      o,
      n.roomId
    ).unmount();
  }, [n, L, B, o]), w(() => {
    if (R)
      return M(
        n.room,
        (O) => {
          o.debug("usePresenceListener(); applying external listener", { roomId: n.roomId });
          const { unsubscribe: U } = O.presence.subscribe(R);
          return () => {
            o.debug("usePresenceListener(); cleaning up external listener", { roomId: n.roomId }), U();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, R, o]), w(() => {
    if (T)
      return M(
        n.room,
        (O) => {
          o.debug("usePresenceListener(); applying onDiscontinuity listener", { roomId: n.roomId });
          const { off: U } = O.presence.onDiscontinuity(T);
          return () => {
            o.debug("usePresenceListener(); removing onDiscontinuity listener", { roomId: n.roomId }), U();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, T, o]), {
    presence: he((O) => O.presence),
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c,
    error: p,
    presenceData: C
  };
}, yi = (r) => {
  const e = W("useRoom"), t = e.roomId;
  k().debug("useRoom();", { roomId: t });
  const { currentStatus: s, error: c } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), o = ie({
    onRoomStatusChange: r == null ? void 0 : r.onStatusChange
  }), d = N(() => e.room.then((l) => l.attach()), [e]), y = N(() => e.room.then((l) => l.detach()), [e]);
  return {
    roomId: t,
    room: ri(),
    attach: d,
    detach: y,
    roomStatus: o.status,
    roomError: o.error,
    connectionStatus: s,
    connectionError: c
  };
}, pi = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("useRoomReactions"), { status: s, error: c } = ie(r), o = k();
  o.trace("useRoomReactions();", { params: r, roomId: n.roomId });
  const d = q(r == null ? void 0 : r.listener), y = q(r == null ? void 0 : r.onDiscontinuity);
  w(() => {
    if (y)
      return M(
        n.room,
        (h) => {
          o.debug("useRoomReactions(); applying onDiscontinuity listener", { roomId: n.roomId });
          const { off: _ } = h.reactions.onDiscontinuity(y);
          return () => {
            o.debug("useRoomReactions(); removing onDiscontinuity listener", { roomId: n.roomId }), _();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, y, o]), w(() => {
    if (d)
      return M(
        n.room,
        (h) => {
          o.debug("useRoomReactions(); applying listener", { roomId: n.roomId });
          const { unsubscribe: _ } = h.reactions.subscribe(d);
          return () => {
            o.debug("useRoomReactions(); removing listener", { roomId: n.roomId }), _();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, d, o]);
  const l = N(
    (h) => n.room.then((_) => _.reactions.send(h)),
    [n]
  );
  return {
    reactions: he((h) => h.reactions),
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c,
    send: l
  };
}, bi = (r) => {
  const { currentStatus: e, error: t } = re({
    onStatusChange: r == null ? void 0 : r.onConnectionStatusChange
  }), n = W("useTyping"), { status: s, error: c } = ie(r), o = k();
  o.trace("useTyping();", { roomId: n.roomId });
  const [d, y] = P(/* @__PURE__ */ new Set()), [l, h] = P(), _ = q(r == null ? void 0 : r.listener), C = q(r == null ? void 0 : r.onDiscontinuity);
  w(() => {
    h(void 0), y((R) => R.size === 0 ? R : /* @__PURE__ */ new Set());
    let p = !0;
    const b = (R) => {
      R === void 0 ? o.debug("useTyping(); clearing error state", { roomId: n.roomId }) : o.error("useTyping(); setting error state", { error: R, roomId: n.roomId }), h(R);
    };
    return n.room.then((R) => {
      if (R.status === m.Attached)
        return R.typing.get().then((T) => {
          p && y(T);
        }).catch((T) => {
          const L = T;
          !p || Ot(L, v.RoomIsReleased) || b(L);
        });
      o.debug("useTyping(); room not attached, setting currentlyTyping to empty", { roomId: n.roomId }), y(/* @__PURE__ */ new Set());
    }).catch(), M(
      n.room,
      (R) => {
        o.debug("useTyping(); subscribing to typing events", { roomId: n.roomId });
        const { unsubscribe: T } = R.typing.subscribe((L) => {
          b(void 0), y(L.currentlyTyping);
        });
        return () => {
          o.debug("useTyping(); unsubscribing from typing events", { roomId: n.roomId }), p = !1, T();
        };
      },
      o,
      n.roomId
    ).unmount();
  }, [n, o]), w(() => {
    if (C)
      return M(
        n.room,
        (p) => {
          o.debug("useTyping(); applying onDiscontinuity listener", { roomId: n.roomId });
          const { off: b } = p.typing.onDiscontinuity(C);
          return () => {
            o.debug("useTyping(); removing onDiscontinuity listener", { roomId: n.roomId }), b();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, C, o]), w(() => {
    if (_)
      return M(
        n.room,
        (p) => {
          o.debug("useTyping(); applying listener", { roomId: n.roomId });
          const { unsubscribe: b } = p.typing.subscribe(_);
          return () => {
            o.debug("useTyping(); removing listener", { roomId: n.roomId }), b();
          };
        },
        o,
        n.roomId
      ).unmount();
  }, [n, _, o]);
  const E = N(() => n.room.then((p) => p.typing.start()), [n]), S = N(() => n.room.then((p) => p.typing.stop()), [n]);
  return {
    typingIndicators: he((p) => p.typing),
    connectionStatus: e,
    connectionError: t,
    roomStatus: s,
    roomError: c,
    error: l,
    start: E,
    stop: S,
    currentlyTyping: d
  };
};
class Et {
  constructor(e) {
    this._queue = [], this._logger = e;
  }
  enqueue(e, t, n) {
    const s = new AbortController(), c = { id: t, options: n, abort: s };
    this._queue.push(c), this._logger.debug("RoomReleaseQueue(); enqueued release", { id: t, options: n }), Promise.resolve().then(() => {
      if (s.signal.aborted) {
        this._logger.debug("RoomReleaseQueue(); aborting release", { id: t, options: n });
        return;
      }
      this._logger.debug("RoomReleaseQueue(); releasing room", { id: t, options: n }), e.rooms.release(t).catch(() => {
      });
    }).catch(() => {
    }).finally(() => {
      this._logger.debug("RoomReleaseQueue(); dequeued release", { id: t, options: n }), this._queue.splice(this._queue.indexOf(c), 1);
    });
  }
  abort(e, t) {
    this._logger.debug("RoomReleaseQueue(); checking for abort", { id: e, options: t, length: this._queue.length });
    const n = this._queue.find((s) => s.id === e && s.options === t);
    n && (this._logger.debug("RoomReleaseQueue(); triggering abort", { id: e, options: t }), n.abort.abort());
  }
  get logger() {
    return this._logger;
  }
}
const Ri = ({
  id: r,
  options: e,
  release: t = !0,
  attach: n = !0,
  children: s
}) => {
  const c = $e(), o = k();
  o.debug("ChatRoomProvider();", { roomId: r, options: e, release: t, attach: n });
  const [d, y] = P(() => {
    o.debug("ChatRoomProvider(); initializing value", { roomId: r, options: e });
    const h = c.rooms.get(r, e);
    return h.catch(() => {
    }), { room: h, roomId: r, options: e, client: c };
  }), l = $(new Et(o));
  return w(() => {
    l.current.logger !== o && (o.debug("ChatRoomProvider(); updating release queue"), l.current = new Et(o));
  }, [o]), w(() => {
    o.debug("ChatRoomProvider(); running lifecycle useEffect", { roomId: r });
    let h = !1, _;
    const C = l.current;
    C.abort(r, e);
    const E = c.rooms.get(r, e);
    return E.catch(() => {
    }), y((S) => S.client === c && S.roomId === r && S.options === e ? (o.debug("ChatRoomProvider(); no change in room id or options", { roomId: r, options: e }), S) : (o.debug("ChatRoomProvider(); updating value", { roomId: r, options: e }), { room: E, roomId: r, options: e, client: c })), E.then((S) => {
      if (h) {
        o.debug("ChatRoomProvider(); unmounted before room resolved", { roomId: r });
        return;
      }
      o.debug("ChatRoomProvider(); room resolved", { roomId: r }), _ = S, n && (o.debug("ChatRoomProvider(); attaching room", { roomId: r }), S.attach().catch(() => {
      }));
    }).catch(() => {
    }), () => {
      if (h = !0, o.debug("ChatRoomProvider(); cleaning up lifecycle useEffect", { roomId: r }), t) {
        o.debug("ChatRoomProvider(); releasing room", { roomId: r }), C.enqueue(c, r, e);
        return;
      } else _ && n && (o.debug("ChatRoomProvider(); detaching room", { roomId: r }), _.detach().catch(() => {
      }));
    };
  }, [r, e, o, n, t, c]), /* @__PURE__ */ Mt(xt.Provider, { value: d, children: s });
};
export {
  hi as AllFeaturesEnabled,
  li as ChatClient,
  di as ChatClientProvider,
  j as ChatMessageActions,
  xt as ChatRoomContext,
  Ri as ChatRoomProvider,
  qe as ConnectionStatus,
  v as ErrorCodes,
  At as LogLevel,
  Y as MessageEvents,
  je as OrderBy,
  br as PresenceEvents,
  m as RoomStatus,
  Ot as errorInfoIs,
  $e as useChatClient,
  re as useChatConnection,
  gi as useMessages,
  fi as useOccupancy,
  _i as usePresence,
  mi as usePresenceListener,
  yi as useRoom,
  pi as useRoomReactions,
  bi as useTyping
};
//# sourceMappingURL=ably-chat.js.map
